<template>
  <div class="store-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong>
                <h3>
                  <router-link :to="{ name: 'outlets_list'}" class="float-left mr-1 main-link">
                    {{$t('store.store_list')}}
                  </router-link>
                  / {{$t('store.store_profile')}}
                </h3>
              </strong>
            </div>

            <legend class="col-sm-2 col-form-label" v-show="!checkPermission($auth.user(),'hide-active')">
              <span style="margin-right: 15px;">
                {{$t('store.active')}}
              </span>
              <c-switch style="margin-top: 0" class="active" type="icon" variant="success"
                        v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.active" :value="1"
                        :uncheckedValue="0" @change="showPopupConfirm()"/>
            </legend>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-card header-tag="header" footer-tag="footer" class="header">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong>{{ $route.params.id ? $t('common.edit') :
              $t('store.basic_information') }}</strong>
              <label class="switch switch-sm switch-text switch-info float-right" @click="updateBasicInformationStatus"
                     v-b-toggle.basic_information_content>
                <i class="fa fa-sort-down" v-if="basicInformationStatus"></i>
                <i class="fa fa-sort-up" v-if="!basicInformationStatus"></i>
              </label>
            </div>
            <b-collapse :visible.sync="basicInformationStatus" id="basic_information_content">
              <b-form class="row">
                <b-col cols="12" v-show="item && typeof $route.params.uuid !== 'undefined'">
                  <b-row class="form-group">
                    <b-col cols="2">
                      {{$t('store.link_to_fcds')}}
                    </b-col>
                    <b-col cols="10">
                      <a class="btn bg-main border-radius-4px pl-3 pr-3"
                         :href="$store.getters.config.main.base_site_url + '/huts/' + item.code"
                         target="_blank">{{$t('common.view')}}</a>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12">
                  <customize-field v-show="!checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable')"
                                  prefix="store" :update="updateCustomizeField" :item="item" type="outlet"
                                   position="before" element="outlet_code"></customize-field>
                  <div class="form-group row" v-show="checkConfig('basic_info', 'store_code', 'show') && !checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable')">
                    <legend class="col-sm-2 col-form-label">{{$t('store.outlet_code')}}</legend>
                    <div class="col-sm-10">
                      <b-form-input :disabled="checkConfig('basic_info', 'store_code', 'disable')" class="form-control"
                                    v-model="item.code"
                                    v-bind:placeholder="$t('store.outlet_code')" :state="!$v.item.code.$invalid"
                                    aria-describedby="code-feedback"/>
                      <b-form-invalid-feedback id="code-feedback">
                        {{ $t('message.required_filed') }}
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                  <div class="form-group row" v-show="checkConfig('basic_info', 'aggregator_code', 'show') && !checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable')">
                    <legend class="col-sm-2 col-form-label">{{$t('store.aggregator_code')}}</legend>
                    <div class="col-sm-10">
                      <b-form-input :disabled="checkConfig('basic_info', 'aggregator_code', 'disable')"
                                    class="form-control" v-model="item.aggregator_code"
                                    v-bind:placeholder="$t('store.aggregator_code')"/>
                    </div>
                  </div>
                  <customize-field  v-show="!checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable')"
                                    prefix="store" :update="updateCustomizeField" :item="item" type="outlet"
                                   position="after" element="outlet_code"></customize-field>
                  <div class="form-group row" v-show="checkConfig('basic_info', 'store_name', 'show') && !checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable')">
                    <legend class="col-sm-2 col-form-label">{{$t('store.outlet_name')}}</legend>
                    <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id">
                      <b-form-input
                        v-model="item.name[lang]"
                        v-bind:placeholder="$t('common.text_'+lang)"
                        :disabled="checkConfig('basic_info', 'store_name', 'disable')"
                        :name="`name[${lang}]`"
                        :state="nameState(lang)"
                        :aria-describedby="'name-feedback' + lang"/>
                      <b-form-invalid-feedback :id="'name-feedback' + lang">
                        {{ $t('message.required_filed') }}
                      </b-form-invalid-feedback>
                    </div>
                  </div>

                  <!-- AC / FSC Name & AC / FSC Code -->
                  <div class="form-group row" v-show="!checkPermission($auth.user(),'rgm-role-editable')">
                    <legend class="col-sm-2 col-form-label" v-show="checkConfig('basic_info', 'acfsc_code', 'show') && !checkPermission($auth.user(),'hide-business-hours-store')">
                      {{$t('store.area_code')}}
                    </legend>
                    <div class="col-sm-4" v-show="checkConfig('basic_info', 'acfsc_code', 'show') && !checkPermission($auth.user(),'hide-business-hours-store')">
                      <b-form-input :disabled="checkConfig('basic_info', 'acfsc_code', 'disable')"
                                    v-model="item.area_code" type="text"></b-form-input>
                    </div>
                    <legend class="col-sm-2 col-form-label" v-show="checkConfig('basic_info', 'acfsc_name', 'show') && !checkPermission($auth.user(),'hide-business-hours-store')">
                      {{$t('store.jpchar')}}
                    </legend>
                    <div class="col-sm-4" v-show="checkConfig('basic_info', 'acfsc_name', 'show') && !checkPermission($auth.user(),'hide-business-hours-store')">
                      <b-form-input :disabled="checkConfig('basic_info', 'acfsc_name', 'disable')" v-model="item.jpchar"
                                    type="text"></b-form-input>
                    </div>
                  </div>
                  <!-- AC / FSC Name & AC / FSC Code -->

                  <!-- outlet code and name -->
                  <div class="form-group row" v-show="!checkPermission($auth.user(),'rgm-role-editable')">
                    <legend class="col-sm-2 col-form-label" v-show="checkConfig('basic_info', 'owner_code', 'show') && !checkPermission($auth.user(),'hide-business-hours-store')">
                      {{$t('store.owner_code')}}
                    </legend>
                    <div class="col-sm-4" v-show="checkConfig('basic_info', 'owner_code', 'show') && !checkPermission($auth.user(),'hide-business-hours-store')">
                      <b-form-input :disabled="checkConfig('basic_info', 'owner_code', 'disable')"
                                    v-model="item.owner_code" type="text"></b-form-input>
                    </div>
                    <legend class="col-sm-2 col-form-label" v-show="checkConfig('basic_info', 'owner_name', 'show') && !checkPermission($auth.user(),'hide-business-hours-store')">
                      {{$t('store.owner_name')}}
                    </legend>
                    <div class="col-sm-4" v-show="checkConfig('basic_info', 'owner_name', 'show') && !checkPermission($auth.user(),'hide-business-hours-store')">
                      <b-form-input :disabled="checkConfig('basic_info', 'owner_name', 'disable')"
                                    v-model="item.owner_name" type="text"></b-form-input>
                    </div>
                  </div>
                  <!-- outlet code and name -->

                  <div class="form-group row" v-show="checkConfig('basic_info', 'street_address', 'show') && !checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable')">
                    <legend class="col-sm-2 col-form-label">{{$t('store.street')}}</legend>
                    <div class="col-sm-10">
                      <div v-for="lang in $store.getters.languages" :key="lang.id">
                        <b-form-input :disabled="checkConfig('basic_info', 'street_address', 'disable')"
                                      ref="auto" id="autocomplete-street" class="form-control"
                                      v-bind:placeholder="$t('common.text_'+lang)"
                                      v-model="item.address[lang]"
                                      type="text">

                        </b-form-input>
                        <div class="clear-both"></div>
                      </div>
                    </div>
                  </div>

                  <!-- phone and fax -->
                  <div class="form-group row" v-show="!checkPermission($auth.user(),'rgm-role-editable')">
                    <legend class="col-sm-2 col-form-label" v-show="checkConfig('basic_info', 'phone', 'show') && !checkPermission($auth.user(),'hide-business-hours-store')">
                      {{$t('store.phone')}}
                    </legend>
                    <div class="col-sm-4" v-show="checkConfig('basic_info', 'phone', 'show') && !checkPermission($auth.user(),'hide-business-hours-store')">
                      <b-form-input :disabled="checkConfig('basic_info', 'phone', 'disable')" v-model="item.phone"
                                    type="text"></b-form-input>
                    </div>
                    <legend class="col-sm-2 col-form-label" v-show="checkConfig('basic_info', 'fax', 'show') && !checkPermission($auth.user(),'hide-business-hours-store')">
                      {{$t('store.fax')}}
                    </legend>
                    <div class="col-sm-4" v-show="checkConfig('basic_info', 'fax', 'show') && !checkPermission($auth.user(),'hide-business-hours-store')">
                      <b-form-input :disabled="checkConfig('basic_info', 'fax', 'disable')" v-model="item.fax"
                                    type="text"></b-form-input>
                    </div>
                  </div>
                  <!-- phone and fax -->

                  <div class="form-group row" v-show="checkConfig('basic_info', 'store_email', 'show') && !checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable')">
                    <legend class="col-sm-2 col-form-label">{{$t('store.outlet_email')}}</legend>
                    <div class="col-sm-10">
                      <b-form-input :disabled="checkConfig('basic_info', 'store_email', 'disable')" v-model="item.email"
                                    type="text"
                                    v-bind:placeholder="$t('store.email')"
                      />
                      <span class="instruction-store-email-text"> {{$t('store.instruction_store_email')}} </span>
                    </div>
                  </div>

                  <div class="form-group row" v-if="outlet_config.config.show_pos_ip_address && !checkPermission($auth.user(),'hide-business-hours-store')">
                    <legend class="col-sm-2 col-form-label">{{ $t('store.outlet_pos_ip') }}</legend>
                    <div class="col-sm-10">
                      <b-form-input
                          type="text"
                          maxlength="25"
                          v-bind:placeholder="$t('store.outlet_pos_ip')"
                          v-model="item.pos_ip"/>
                    </div>
                  </div>

                  <div class="form-group row" v-if="outlet_config.config.show_gst_number && !checkPermission($auth.user(),'hide-business-hours-store')">
                    <legend class="col-sm-2 col-form-label">{{ $t('store.outlet_gst_number') }}</legend>
                    <div class="col-sm-10">
                      <b-form-input
                          type="text"
                          maxlength="25"
                          v-bind:placeholder="$t('store.outlet_gst_number')"
                          v-model="item.gst_number"/>
                    </div>
                  </div>

                  <div class="form-group row" v-if="outlet_config.config.show_payment_click_id && !checkPermission($auth.user(),'hide-business-hours-store')">
                    <legend class="col-sm-2 col-form-label">{{$t('store.merchant_payment_click_id')}}</legend>
                    <div class="col-sm-10">
                      <b-form-input
                          type="text"
                          maxlength="50"
                          v-model="item.merchant_payment_click_id"
                          v-bind:placeholder="$t('store.merchant_payment_click_id')"/>
                    </div>
                  </div>

                  <div class="form-group row" v-show="checkConfig('basic_info', 'description', 'show') && !checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable')">
                    <legend class="col-sm-2 col-form-label">{{$t('store.outlet_description')}}</legend>
                    <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id">
                      <b-form-textarea :label-cols="5" v-model="item.description[lang]"
                                       :rows="5" :max-rows="10"
                                       :disabled="checkConfig('basic_info', 'description', 'disable')"
                                       v-bind:placeholder="$t('common.text_'+lang)">
                      </b-form-textarea>
                    </div>
                  </div>

                  <div class="form-group row remark" v-show="checkConfig('basic_info', 'remark', 'show') && !checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable')">
                    <legend class="col-sm-2 col-form-label">{{$t('store.remark')}}</legend>
                    <div class="col-sm-10">
                      <div v-for="(remark, index) in item.remarks" :key="index" class="remark-row">
                        <b-form-input :disabled="checkConfig('basic_info', 'remark', 'disable')" class="form-control"
                                      v-model="remark.value" type="text"></b-form-input>
                        <b-button v-if="index > 0" variant="danger" v-on:click="removeRemark(index)" size="sm"><i
                          class="fa fa-trash"></i></b-button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row" v-show="checkConfig('basic_info', 'remark', 'show') && !checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable')">
                    <legend class="col-sm-2 col-form-label"></legend>
                    <div class="col-sm-10">
                      <a :disabled="checkConfig('basic_info', 'remark', 'disable')" class="add-more"
                         v-on:click="addRemark()"><i class="fa fa-plus"></i>{{$t('common.add_more')}}</a>
                    </div>
                  </div>

                  <div class="form-group row" v-show="checkConfig('basic_info', 'google_search_location', 'show') && !checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable')">
                    <legend class="col-sm-2 col-form-label">{{$t('store.location')}}</legend>
                    <div class="col-sm-10">
                      <b-form-input :disabled="checkConfig('basic_info', 'google_search_location', 'disable')"
                                    ref="auto" id="autocomplete" class="form-control"
                                    v-bind:placeholder="$t('store.placeholder_enteraddress')" v-model="item.street"
                                    type="text"></b-form-input>
                    </div>
                  </div>

                  <div class="form-group row"
                       v-show="(outlet_config.config.draw_delivery_area || outlet_config.config.upload_kml) && !checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable')">
                    <legend class="col-sm-2 col-form-label" v-show="outlet_config.config.draw_delivery_area">
                      {{$t('store.delivery_zone')}}
                    </legend>

                    <div class="col-sm-10" v-show="outlet_config.config.draw_delivery_area && !checkPermission($auth.user(),'hide-business-hours-store')">
                      <div style="display: inline-block;" class="mr-2">
                        <b-button style="height:33px;margin-bottom: 4px;" :class="'draw-map'"
                          @click="openMap" :variant="'danger'"><strong>{{$t('store.draw_map')}}</strong>
                        </b-button>
                      </div>
                      <div class="mr-2" style="display: inline-block" v-show="outlet_config.config.upload_kml && !checkPermission($auth.user(),'hide-business-hours-store')">
                        <label class="file-select">
                          <div class="select-button" style="margin-top: 6px; padding-bottom: 6px;">
                            <span class="pr-1 pl-1">{{$t('store.upload_kml_file')}}</span>
                          </div>
                          <input style="height:33px; width:141px;" type="file" @change="uploadKmlFile"></input>
                        </label>
                      </div>
                      <div style="display: inline-block;" class="mr-2">
                        <b-button style="height:33px;margin-bottom: 4px; border-radius: 0.2rem;" :class="'manage-tradezone'"
                                  @click="manageTradezone" :variant="'danger'"><strong>{{$t('store.manage_tradezone')}}</strong>
                        </b-button>
                      </div>
                      <div class="mr-2 box-export-tradezone" v-show="showButtonExportTradezone() && outlet_config.config.export_tradezone">
                        <b-button class="export-tradezone"
                          @click="exportTradezone(item)" :variant="'primary'"><strong>{{$t('store.export_tradezone')}}</strong>
                        </b-button>
                      </div>
                    </div>
                  </div>

                  <!-- Long & lat -->
                  <div class="form-group row" v-show="!checkPermission($auth.user(),'rgm-role-editable')">
                    <legend class="col-sm-2 col-form-label" v-show="checkConfig('basic_info', 'latitude', 'show') && !checkPermission($auth.user(),'hide-business-hours-store')">
                      {{$t('store.lat')}}
                    </legend>
                    <div class="col-sm-4" v-show="checkConfig('basic_info', 'latitude', 'show') && !checkPermission($auth.user(),'hide-business-hours-store')">
                      <b-form-input :disabled="checkConfig('basic_info', 'latitude', 'disable')" v-model="item.lat"
                                    type="text"
                                    v-bind:placeholder="$t('store.lat')" :state="!$v.item.lat.$invalid"
                                    aria-describedby="lat-feedback"/>
                      <b-form-invalid-feedback id="lat-feedback">
                        {{ $t('message.required_filed') }}
                      </b-form-invalid-feedback>
                    </div>
                    <legend class="col-sm-2 col-form-label" v-show="checkConfig('basic_info', 'longitude', 'show') && !checkPermission($auth.user(),'hide-business-hours-store')">
                      {{$t('store.long')}}
                    </legend>
                    <div class="col-sm-4" v-show="checkConfig('basic_info', 'longitude', 'show') && !checkPermission($auth.user(),'hide-business-hours-store')">
                      <b-form-input :disabled="checkConfig('basic_info', 'longitude', 'disable')" v-model="item.long"
                                    type="text"
                                    v-bind:placeholder="$t('store.long')" :state="!$v.item.long.$invalid"
                                    aria-describedby="long-feedback"/>
                      <b-form-invalid-feedback id="long-feedback">
                        {{ $t('message.required_filed') }}
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                  <!-- Long & lat -->

                  <div class="form-group row" v-show="checkConfig('basic_info', 'accept_online_order', 'show') && !checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable')">
                    <legend class="col-sm-2 col-form-label">{{$t('store.orders_method')}}</legend>
                    <div class="col-sm-6">
                      <c-switch-custom :disabled="checkConfig('basic_info', 'accept_online_order', 'disable')" type="icon"
                                variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true"
                                v-model="item.online_orders" :value="1" :uncheckedValue="0"/>

                      <span style="line-height: 32px">※{{$t('store.description_order_online')}}</span>
                    </div>
                  </div>

                  <div class="form-group row" v-show="checkConfig('basic_info', 'alcohol_treatment', 'show') && !checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable')">
                    <legend class="col-sm-2 col-form-label">{{$t('store.alcohol_drinks_available')}}</legend>
                    <div class="col-sm-4">
                      <c-switch-custom :disabled="checkConfig('basic_info', 'alcohol_treatment', 'disable')" type="icon"
                                variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true"
                                v-model="item.alcohol_drinks_available" :value="1" :uncheckedValue="0"/>
                    </div>
                  </div>

                  <div class="form-group row" v-if="outlet_config.config.support_maintainance">
                    <legend class="col-sm-2 col-form-label">{{$t('store.refurbishment')}}</legend>
                    <div class="col-sm-4">
                      <c-switch type="icon"
                                variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true"
                                v-model="item.refurbishment" :value="1" :uncheckedValue="0"/>
                    </div>
                  </div>

                  <!-- Available depositions -->
                  <div class="form-group row depositions"
                       v-show="checkConfig('basic_info', 'available_dispositions', 'show') && !checkPermission($auth.user(),'hide-available-disposition')">
                    <legend class="col-sm-2 col-form-label">{{$t('store.available_disposition')}}</legend>

                    <legend class="col-sm-2 col-form-label label">{{$t('common.delivery')}}</legend>
                    <c-switch :disabled="checkConfig('basic_info', 'available_dispositions', 'disable')" type="icon"
                              variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="delivery"
                              :value="1" :uncheckedValue="0"/>
                    <legend class="col-sm-2 col-form-label label-collection">{{$t('common.takeaway')}}</legend>
                    <c-switch :disabled="checkConfig('basic_info', 'available_dispositions', 'disable')" type="icon"
                              variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="collection"
                              :value="1" :uncheckedValue="0"/>
                    <legend class="col-sm-2 col-form-label label-restaurant" v-show="outlet_config.config.restaurant">{{$t('common.restaurant')}}</legend>
                    <c-switch v-show="outlet_config.config.restaurant" :disabled="checkConfig('basic_info', 'available_dispositions', 'disable')" type="icon"
                              variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="restaurant"
                              :value="1" :uncheckedValue="0"/>
                  </div>
                  <!-- Available depositions -->

                  <!-- Minimum cart value -->
                  <div class="form-group row" v-show="checkConfig('basic_info', 'minimum_cart_value', 'show') && !checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable')">
                    <legend class="col-sm-2 col-form-label">{{$t('store.min_cart')}}</legend>

                    <legend class="col-sm-1 col-form-label">{{$t('common.delivery')}}</legend>
                    <div class="col-sm-4">
                      <b-form-input class="form-control" v-model="item.min_cart.D" type="text"
                                    :disabled="checkConfig('basic_info', 'minimum_cart_value', 'disable')"></b-form-input>
                    </div>
                    <legend class="col-sm-1 col-form-label">{{$t('common.takeaway')}}</legend>
                    <div class="col-sm-4">
                      <b-form-input class="form-control" v-model="item.min_cart.C" type="text"
                                    :disabled="checkConfig('basic_info', 'minimum_cart_value', 'disable')"></b-form-input>
                    </div>
                  </div>
                  <!-- Minimum cart value -->

                  <!-- Estimated time -->
                  <div class="form-group row" v-if="checkConfig('basic_info', 'estimated_time', 'show') && !checkPermission($auth.user(),'hide-estimated-time')">
                    <legend class="col-sm-2 col-form-label">{{$t('store.quote_time')}}</legend>

                    <legend class="col-sm-1 col-form-label">{{$t('common.delivery')}}</legend>
                    <div class="col-sm-4">
                      <b-form-select :options="estimateTime.D" v-model="item.quote_time.D"
                                     :disabled="checkConfig('basic_info', 'estimated_time', 'disable')" v-if="!outlet_config.config.free_text_estimated_time">
                      </b-form-select>
                      <b-form-input class="form-control" v-model="item.quote_time.D" type="text"
                                    :disabled="checkConfig('basic_info', 'estimated_time', 'disable')" v-if="outlet_config.config.free_text_estimated_time"></b-form-input>
                    </div>
                    <legend class="col-sm-1 col-form-label">{{$t('common.takeaway')}}</legend>
                    <div class="col-sm-4">
                      <b-form-select :options="estimateTime.C" v-model="item.quote_time.C" v-if="!outlet_config.config.free_text_estimated_time"
                                     :disabled="checkConfig('basic_info', 'estimated_time', 'disable')">
                      </b-form-select>
                      <b-form-input class="form-control" v-model="item.quote_time.C" type="text"
                                    :disabled="checkConfig('basic_info', 'estimated_time', 'disable')" v-if="outlet_config.config.free_text_estimated_time"></b-form-input>
                    </div>
                  </div>
                  <!-- Estimated time -->
                  <!-- Interval time -->

                  <div class="form-group row" v-if="checkConfig('basic_info', 'interval_time', 'show') && !checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable')">
                    <legend class="col-sm-2 col-form-label">{{$t('store.interval_time')}}</legend>

                    <legend class="col-sm-1 col-form-label">{{$t('common.delivery')}}</legend>
                    <div class="col-sm-4">
                      <b-form-select :options="intervalTime.D" v-model="item.duration.D" :disabled="checkConfig('basic_info', 'interval_time', 'disable')" >
                      </b-form-select>
                      
                    </div>
                    <legend class="col-sm-1 col-form-label">{{$t('common.takeaway')}}</legend>
                    <div class="col-sm-4">
                      <b-form-select :options="intervalTime.C" v-model="item.duration.C" :disabled="checkConfig('basic_info', 'interval_time', 'disable')">
                      </b-form-select>
                      
                    </div>
                  </div>
                  <!-- Interval time -->
                  <!-- Delivery fee-->
                  <div class="form-group row" v-show="checkConfig('basic_info', 'delivery_fee', 'show') && !checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable')">
                    <legend class="col-sm-2 col-form-label">{{$t('store.delivery_fee')}}</legend>
                    <div class="col-sm-4">
                      <b-form-input class="form-control" v-model="item.delivery_fee" type="text"
                                    :disabled="checkConfig('basic_info', 'delivery_fee', 'disable')"></b-form-input>
                    </div>
                  </div>
                  <!-- Delivery fee-->
                  <!-- Service fee-->
                  <div class="form-group row" v-show="outlet_config.config.service_fee && !checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable')">
                    <legend class="col-sm-2 col-form-label">{{$t('store.service_fee')}}</legend>
                    <div class="col-sm-2">
                      <c-switch type="icon" variant="success"
                                v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="serviceFee.active"
                                :value="1" :uncheckedValue="0"/>
                    </div>
                  </div>
                  <div class="form-group row" v-show="outlet_config.config.service_fee && serviceFee.active && !checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable')">
                    <legend class="col-sm-2 col-form-label"></legend>
                    <legend class="col-sm-1 col-form-label">{{$t('common.name')}}</legend>
                    <div v-for="lang in $store.getters.languages" class="col-sm-3" :key="lang.id">
                      
                      <b-form-input type="text"
                                    :id="`name-${lang}`"
                                    :name="`service-name-${lang}`"
                                    class="form-control border-radius-4px"
                                    v-model="serviceFee.name[lang]"
                                    v-bind:placeholder="$t('common.text_' + lang)"
                                    :state="stateService(serviceFee.name)"
                      />
                      <b-form-invalid-feedback :id="`service-name-${lang}-feedback`">
                        {{ $t('message.required_filed') }}
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                  <div class="form-group row" v-show="outlet_config.config.service_fee && serviceFee.active && !checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable')">
                    <legend class="col-sm-2 col-form-label"></legend>
                    <legend class="col-sm-1 col-form-label">{{$t('common.price')}}</legend>
                    <div class="col-sm-2">
                      <b-form-input type="number"
                                    name="service-price"
                                    class="form-control border-radius-4px"
                                    min="1"
                                    v-model="serviceFee.price"
                                    :state="stateService(serviceFee.price)"
                      />
                      <b-form-invalid-feedback id="serive-price-feedback">
                        {{ $t('message.required_filed') }}
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                  <div class="form-group row" v-show="outlet_config.config.service_fee && serviceFee.active && !checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable')">
                    <legend class="col-sm-2 col-form-label"></legend>
                    <legend class="col-sm-1 col-form-label">{{$t('common.from')}}</legend>
                    
                    <div class="col-sm-2">
                      <date-picker-input
                        className="form-control col-sm-5 float-left time-service-from-border"
                        name="date-from"
                        type="time"
                        v-model="serviceFee.time_apply.from"
                        :lang="$session.get('lang')"
                        :hasPicker="true"
                        formatInput="HH:mm"
                        formatOutput="HH:mm"
                        :change="(e) => serviceFee.time_apply.from = e"
                      />
                    </div>

                    <legend class="col-sm-1 col-form-label">{{$t('common.to')}}</legend>

                    <div class="col-sm-2">
                      <date-picker-input
                        className="form-control col-sm-5 float-left time-service-to-border"
                        name="date-to"
                        type="time"
                        v-model="serviceFee.time_apply.to"
                        :lang="$session.get('lang')"
                        :hasPicker="true"
                        formatInput="HH:mm"
                        formatOutput="HH:mm"
                        :change="(e) => serviceFee.time_apply.to = e"
                      />
                    </div>
                  </div>
                  <!-- Service fee-->
                  <!-- Tax fee -->
                   <div class="form-group row" v-if="outlet_config.config.support_tax_fee">
                    <legend class="col-sm-2 col-form-label">{{$t('store.tax_fee')}}</legend>
                    <div class="col-sm-4">
                      <b-form-input class="form-control" v-model="item.tax_fee" type="number"></b-form-input>
                    </div>
                  </div>
                  <!-- Tax fee -->
                  <customize-field prefix="store" :update="updateCustomizeField" :item="item" type="outlet"
                                   position="before" element="business_period"></customize-field>
                  <!-- Business Period -->
                  <div class="form-group row" v-show="checkConfig('basic_info', 'business_period', 'show') && !checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable')">
                    <legend class="col-sm-2 col-form-label">{{$t('store.outlet_open_time')}}</legend>
                    <div class="col-sm-4">
                      <masked-input :disabled="checkConfig('basic_info', 'business_period', 'disable')" type="text"
                                    name="date" class="form-control col-sm-5 float-left" v-model="item.from_date"
                                    :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, ' ', /\d/,/\d/,':',/\d/,/\d/,':',/\d/,/\d/]" :guide="true"
                                    placeholderChar="_" :showMask="true" :keepCharPositions="true">
                      </masked-input>
                      <div class="form-control col-sm-2 float-left text-center">
                        <div><i class="fa fa-minus"></i></div>
                      </div>
                      <masked-input :disabled="checkConfig('basic_info', 'business_period', 'disable')" type="text"
                                    name="date" class="form-control col-sm-5 float-left" v-model="item.to_date"
                                    :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, ' ', /\d/,/\d/,':',/\d/,/\d/,':',/\d/,/\d/]" :guide="true"
                                    placeholderChar="_" :showMask="true" :keepCharPositions="true">
                      </masked-input>
                    </div>
                  </div>
                  <!-- Business Period -->
                  <customize-field input_type="number" onkeyup="this.value < 1 ? this.value=1 : this.value=this.value" prefix="store" :update="updateCustomizeField" :item="item" type="outlet"
                                   position="after" element="business_period"></customize-field>
                  <!--  -->
                  <!-- Time zones v-if="checkConfig('basic_info', 'time_zones', 'show')" -->
                  <div class="form-group row" v-show="!checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable')">
                    <legend class="col-sm-2 col-form-label">{{$t('store.time_zones')}}</legend>
                    <div class="col-sm-4" v-if="checkConfig('basic_info', 'time_zones', 'show')">

                      <Multiselect
                        v-model="current_timezone"
                        v-bind:placeholder="$t('store.time_zones')"
                        label="time_zone"
                        track-by="time_zone"
                        :options="item.time_zones"
                        v-bind:disabled="checkConfig('basic_info', 'time_zones', 'disable')">
                      </Multiselect>

                    </div>
                    <div v-else class="col-sm-4">
                      <b-form-input class="form-control" readonly="readonly" v-model="current_timezone.time_zone" type="text"></b-form-input>
                    </div>
                  </div>
                  <!-- Time zones -->
                  <div class="form-group row" v-show="!checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable')">
                    <legend class="col-sm-2 col-form-label">{{$t('topping.tier')}}</legend>
                    <div class="col-sm-4">
                      <select class="form-control" v-model="item.tier">
                        <option v-for="(name, index) in $store.getters.config.main.tiers" :value="index">{{name != null ? name : index}}</option>
                      </select>
                    </div>
                  </div>
                </b-col>
                
              </b-form>
            </b-collapse>

            <div slot="footer">
              <router-link :to="{ name: 'outlets_list', query: {rollback: 1}}"
                           class="btn border-radius-4px bg-main float-left ml-4"><i class="fa fa-arrow-left"></i>
                {{$t('common.back')}}
              </router-link>
              <div class="btn-save">
                <b-button style="margin-right: 50px;" variant="success" v-if="isShowPublishButton" v-on:click="pushMenuForOutlets">&nbsp;
                  {{$t('common.push_menu_and_combo_to_production')}}
                </b-button>
                <span v-if="!isShowPublishButton" style="padding-right: 20px; font-weight: bold;" > {{$t('common.publishing')}} ... </span>
                <b-button :disabled="checkSubmit()" variant="success" v-on:click="saveOutlet">&nbsp; {{ $route.params.id
                  ? $t('common.update') : $t('common.save')}}
                </b-button>
              </div>
            </div>
          </b-card>
          <!-- Table ID -->
          <b-card v-show="outlet_config.config.table_control && restaurant && !checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable')">
            <div class="row">
              <div class="col-sm-2">{{$t('store.table_control')}}</div>
              <div class="col-sm-10">
                <router-link class="btn bg-main border-radius-4px pl-3 pr-3"
                            :to="{name: 'table-control', params: { uuid: $route.params.uuid }}">
                  {{$t('common.view')}}
                </router-link>
              </div>
            </div>
          </b-card>
          <!-- End Table ID -->
          <!--Code Validate-->
          <b-card cols="12" v-show="!checkPermission($auth.user(),'hide-business-hours-store') && outlet_config.config.code_validate && restaurant">
            <b-row class="form-group">
              <b-col cols="2">
                {{$t('store.code_validate')}}
                <p>(The code will be reset daily at 5am)</p>
              </b-col>
              <b-col cols="10">
                <span><strong>{{item.code_validate}}</strong></span> 
              </b-col>
            </b-row>
          </b-card>
          <!--End Code Validate-->
          <b-card header-tag="header" footer-tag="footer" v-show="!checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable')">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong>{{ $t('store.payment_information') }}</strong>
              <label class="switch switch-sm switch-text switch-info float-right"
                     @click="updatePaymentInformationStatus" v-b-toggle.payment_information_content>
                <i class="fa fa-sort-down" v-if="paymentInformationStatus"></i>
                <i class="fa fa-sort-up" v-if="!paymentInformationStatus"></i>
              </label>
            </div>
            <b-collapse :visible.sync="paymentInformationStatus" id="payment_information_content">
              <b-form class="row">
                <b-col cols="12">
                  <customize-field prefix="store" :update="updateCustomizeField" :item="item" type="outlet"
                                   position="after" element="payment_information"></customize-field>
                  <div class="form-group font-weight-bold row">
                    <legend class="col-sm-2 border-bottom col-form-label">Display Name</legend>
                    <legend class="col-sm-8 border-bottom col-form-label">Description</legend>
                    <legend class="col-sm-1 border-bottom col-form-label">Status</legend>
                  </div>
                  <div v-for="(item, k) in payment_method">
                    <div class="form-group row">
                      <legend class="col-sm-2 col-form-label">{{item.display_name}}</legend>
                      <div class="col-sm-8 pt-2">{{item.description || ''}}</div>
                      <div class="col-sm-1" v-if="payment_accepted[item.code] != null">
                        <c-switch-custom v-model="payment_accepted[item.code].active" type="icon" variant="success"
                                  v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" :value="1" :uncheckedValue="0"
                                  @change="updatePaymentMethod"/>
                      </div>
                    </div>
                  </div>
                  <customize-field prefix="store" :update="updateCustomizeField" :item="item" type="outlet"
                                   position="before" element="payment_information"></customize-field>
                </b-col>
              </b-form>
            </b-collapse>
          </b-card>
          <b-card header-tag="header" footer-tag="footer" v-show="checkConfig('basic_info', 'aggregators', 'show') && !checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable')">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong>{{ $t('store.aggregators') }}</strong>
              <label class="switch switch-sm switch-text switch-info float-right" @click="updateAggregatorsStatus"
                     v-b-toggle.aggregators_content>
                <i class="fa fa-sort-down" v-if="aggregatorsStatus"></i>
                <i class="fa fa-sort-up" v-if="!aggregatorsStatus"></i>
              </label>
            </div>
            <b-collapse :visible.sync="aggregatorsStatus" id="aggregators_content">
              <b-form class="row">
                <b-col cols="12">
                  <customize-field prefix="store" :update="updateCustomizeField" :item="item" type="outlet"
                                   position="before" element="payment_information"></customize-field>

                  <div class="form-group row" v-for="(value, item) in aggregators" v-if="value == 1 && !checkUberEats(item)">
                    <legend class="col-sm-2 col-form-label">{{$t('store.' + item)}}</legend>
                    <div class="col-sm-2">
                      <c-switch :disabled="checkConfig('basic_info', 'aggregators', 'disable')"
                                @change="updateAggregators(aggregators_data[item], item)" type="icon" variant="success"
                                v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="aggregators_data[item]"
                                :value="1" :uncheckedValue="0"/>

                    </div>
                  </div>

                  <customize-field prefix="store" :update="updateCustomizeField" :item="item" type="outlet"
                                   position="after" element="aggregators"></customize-field>
                </b-col>
              </b-form>
            </b-collapse>
          </b-card>
          <b-card header-tag="header" footer-tag="footer" v-show="checkConfig('basic_info', 'aggregators', 'show') && !checkPermission($auth.user(),'hide-business-hours-store') && !checkPermission($auth.user(),'rgm-role-editable') && checkUberEats(null)">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong>{{ $t('store.ubereats') }}</strong>
              <label class="switch switch-sm switch-text switch-info float-right" @click="updateUberEatsStatus"
                     v-b-toggle.ubereats_content>
                <i class="fa fa-sort-down" v-if="uberEatsStatus"></i>
                <i class="fa fa-sort-up" v-if="!uberEatsStatus"></i>
              </label>
            </div>
            <b-collapse :visible.sync="uberEatsStatus" id="ubereats_content">
              <b-form class="row">
                <b-col cols="12">
                  <customize-field prefix="store" :update="updateCustomizeField" :item="item" type="outlet"
                                   position="before" element="payment_information"></customize-field>

                  <div class="form-group row" v-for="(value, item) in aggregators" v-if="value == 1 && checkUberEats(item)">
                    <legend class="col-sm-2 col-form-label">{{$t('store.' + item)}}</legend>
                    <div class="col-sm-2">
                      <c-switch :disabled="checkConfig('basic_info', 'aggregators', 'disable')"
                                @change="updateAggregators(aggregators_data[item], item)" type="icon" variant="success"
                                v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="aggregators_data[item]"
                                :value="1" :uncheckedValue="0"/>

                    </div>
                  </div>

                  <customize-field prefix="store" :update="updateCustomizeField" :item="item" type="outlet"
                                   position="after" element="aggregators"></customize-field>
                </b-col>
              </b-form>
            </b-collapse>
          </b-card>

          <b-card header-tag="header" footer-tag="footer"
                  v-if="checkConfig('time_settings_information', 'business_hours', 'show') && !checkPermission($auth.user(),'hide-business-hours-store')
                        || checkConfig('time_settings_information', 'lunch_time', 'show') && !checkPermission($auth.user(),'hide-lunch-time-hours-store')
                        || checkConfig('time_settings_information', 'calendar', 'show') && !checkPermission($auth.user(),'hide-calendar-store')">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong>{{$t('store.time_settings_information') }}</strong>
              <label class="switch switch-sm switch-text switch-info float-right"
                     @click="updateTimeSettingsInformationStatus" v-b-toggle.time_settings_information_content>
                <i class="fa fa-sort-down" v-if="timeSettingsInformationStatus"></i>
                <i class="fa fa-sort-up" v-if="!timeSettingsInformationStatus"></i>
              </label>
            </div>
            <b-collapse :visible.sync="timeSettingsInformationStatus" id="time_settings_information_content">
              <b-form class="row">
                <b-col cols="12">
                  <customize-field prefix="store" :update="updateCustomizeField" :item="item" type="outlet"
                                   position="after" element="time_settings_information"></customize-field>
                  <!-- Business hours -->
                  <div class="form-group row" v-if="checkConfig('time_settings_information', 'business_hours', 'show')
                                                && !checkPermission($auth.user(),'hide-business-hours-store')">
                    <legend class="col-sm-2 col-form-label">{{$t('store.business_hours')}}</legend>

                    <div class="col-sm-10">
                      <div class="gray-background">
                        <div v-for="(businesshour, index) in item.businessHours" :key="index" class="row remark-row">
                          <div class="col-sm-9">
                            <div class="business-hours">
                              <b-form-checkbox
                                :disabled="checkConfig('time_settings_information', 'business_hours', 'disable')"
                                v-for="(b,k) in businesshour" class="form-check form-check-inline" :key="k+0"
                                v-if="checkDateRange(b.date)" :value="b.date" unchecked-value=""
                                v-model="businesshour[10].value" plain>{{$t(b.date)}}
                              </b-form-checkbox>
                            </div>
                          </div>
                          <div class="col-sm-1">
                            <masked-input
                              :disabled="checkConfig('time_settings_information', 'business_hours', 'disable')"
                              type="text" name="date" v-model="item.businessHours[index][8].value" class="form-control"
                              :mask="[/\d/, /\d/, ':', /\d/, /\d/]" :guide="true" placeholderChar="_" :showMask="true"
                              :keepCharPositions="true">
                            </masked-input>
                          </div>
                          <div class="col-sm-1">
                            <masked-input
                              :disabled="checkConfig('time_settings_information', 'business_hours', 'disable')"
                              type="text" name="date" v-model="item.businessHours[index][9].value" class="form-control"
                              :mask="[/\d/, /\d/, ':', /\d/, /\d/]" :guide="true" placeholderChar="_" :showMask="true"
                              :keepCharPositions="true">
                            </masked-input>
                          </div>
                          <div class="col-sm-1" v-if="outlet_config.config.separate_open_hours">
                            <b-input-group>
                              <b-form-select v-model="item.businessHours[index][11].value" v-bind:value="item.businessHours[index][11].value" :options="order_types[$session.get('lang')]" v-bind:placeholder="$t('order.order_type')">
                              </b-form-select>
                            </b-input-group>
                          </div>
                          <div v-if="index > 0" class="col-sm-1">
                            <b-button :disabled="checkConfig('time_settings_information', 'business_hours', 'disable')"
                                      variant="danger" v-on:click="removeBusinessHours(index)" size="sm"><i
                              class="fa fa-trash"></i></b-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row" v-if="checkConfig('time_settings_information', 'business_hours', 'show')
                                                    && !checkPermission($auth.user(),'hide-business-hours-store')">
                    <legend class="col-sm-2 col-form-label"></legend>

                    <div class="col-sm-10">
                      <a class="add-more"
                         v-on:click="checkConfig('time_settings_information', 'business_hours', 'disable') ? false : addBusinessHours()"><i
                        class="fa fa-plus"></i>{{$t('common.add_more')}}</a>
                    </div>
                  </div>
                  <!-- Business hours -->

                  <!-- Lunch time -->
                  <div class="form-group row" v-if="checkConfig('time_settings_information', 'lunch_time', 'show')
                                                    && !checkPermission($auth.user(),'hide-lunch-time-hours-store')">
                    <legend class="col-sm-2 col-form-label">{{$t('store.lunch_time')}}</legend>

                    <div class="col-sm-10">
                      <div class="gray-background">
                        <div v-for="(lunchtime, index) in item.lunchTimeHours" :key="index" class="row remark-row">
                          <div class="col-sm-9">
                            <div class="business-hours">
                              <b-form-checkbox
                                :disabled="checkConfig('time_settings_information', 'lunch_time', 'disable')"
                                v-for="(l,key) in lunchtime" class="form-check form-check-inline" :key="key+0"
                                v-if="checkDateRange(l.date)" :value="l.date" unchecked-value=""
                                v-model="lunchtime[10].value" plain>{{$t(l.date)}}
                              </b-form-checkbox>
                            </div>
                          </div>
                          <div class="col-sm-1">
                            <masked-input :disabled="checkConfig('time_settings_information', 'lunch_time', 'disable')"
                                          type="text" name="date" class="form-control"
                                          v-model="item.lunchTimeHours[index][8].value"
                                          :mask="[/\d/, /\d/, ':', /\d/, /\d/]" :guide="true" placeholderChar="_"
                                          :showMask="true" :keepCharPositions="true">
                            </masked-input>
                          </div>
                          <div class="col-sm-1">
                            <masked-input :disabled="checkConfig('time_settings_information', 'lunch_time', 'disable')"
                                          type="text" name="date" class="form-control"
                                          v-model="item.lunchTimeHours[index][9].value"
                                          :mask="[/\d/, /\d/, ':', /\d/, /\d/]" :guide="true" placeholderChar="_"
                                          :showMask="true" :keepCharPositions="true">
                            </masked-input>
                          </div>
                          <div v-if="index > 0" class="col-sm-1">
                            <b-button :disabled="checkConfig('time_settings_information', 'lunch_time', 'disable')"
                                      variant="danger" v-on:click="removeLunchTimeHours(index)" size="sm"><i
                              class="fa fa-trash"></i></b-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row" v-if="checkConfig('time_settings_information', 'lunch_time', 'show')
                                                    && !checkPermission($auth.user(),'hide-lunch-time-hours-store')">
                    <legend class="col-sm-2 col-form-label"></legend>

                    <div class="col-sm-10">
                      <a class="add-more"
                         v-on:click="checkConfig('time_settings_information', 'lunch_time', 'disable') ? false : addLunchTimeHours()"><i
                        class="fa fa-plus"></i>{{$t('common.add_more')}}</a>
                    </div>
                  </div>
                  <!-- Lunch time -->

                  <!-- Calendar -->
                  <div class="form-group row" v-if="checkConfig('time_settings_information', 'calendar', 'show')
                                                  && !checkPermission($auth.user(),'hide-calendar-store')">
                    <legend class="col-sm-2 col-form-label">{{$t('store.calendar')}}</legend>

                    <div class="col-sm-10">
                      <b-button :disabled="checkConfig('time_settings_information', 'calendar', 'disable')"
                                variant="success" v-on:click="openCalendar()">{{$t('store.view_calendar')}}
                      </b-button>
                    </div>
                  </div>
                  <!-- Calendar -->
                  <customize-field prefix="store" :update="updateCustomizeField" :item="item" type="outlet"
                                   position="before" element="time_settings_information"></customize-field>

                </b-col>
              </b-form>
            </b-collapse>
          </b-card>
          <b-card v-show="(typeof this.$route.params.uuid !== 'undefined' && this.$route.params.uuid) &&
          (outlet_config.config && (typeof outlet_config.config.show_menu_control === 'undefined' || outlet_config.config.show_menu_control !== false)) &&
          (!checkPermission($auth.user(),'hide-menu-control'))">
            <div class="row">
              <div class="col-sm-2">{{$t('store.menu_control')}}</div>
              <div class="col-sm-10">
                <router-link class="btn bg-main border-radius-4px pl-3 pr-3"
                             :to="(clientId === client_uuid.uk1 || clientId === client_uuid.uk2) ? {name: 'menu_out_of_stock', params: { uuid: this.$route.params.uuid }} : {name: outlet_config.config.show_menu_exclusion === true ? 'menu_control' : 'outlet_out_of_stock', params: { uuid: this.$route.params.uuid }}">
                  {{$t('common.view')}}
                </router-link>
              </div>
            </div>
          </b-card>
          <div v-show="typeof this.$route.params.uuid !== 'undefined' && !checkPermission($auth.user(),'hide-business-hours-store')" style="padding: 0px 15px;" v-if="checkPermissionAdmin($auth.user(), 'get.v1.product-menu-be.list_half_firsts_and_seconds')">
            <div class="row">
              <b-card header-tag="header" footer-tag="footer" class="col-sm-6" style="padding: 0">
                <div slot="header">
                  <i className="fa fa-align-justify"></i><strong>{{ $t('store.size_half') }}</strong>
                  <label class="switch switch-sm switch-text switch-info float-right"
                         @click="updateFirstInformationStatus" v-b-toggle.first_information_content>
                    <i class="fa fa-sort-down" v-if="firstInformationStatus"></i>
                    <i class="fa fa-sort-up" v-if="!firstInformationStatus"></i>
                  </label>
                </div>
                <b-collapse :visible.sync="firstInformationStatus" id="first_information_content">
                  <table class="table table-striped table-hover table-sm header-pointer">
                    <thead class="table-thead">
                    <tr>
                      <th class="thead-th" width="100" v-if="outlet_config.config.show_menu_control_half_half">
                        {{$t('store.exclusion_target')}}
                      </th>
                      <th scope="col" class="thead-th" width="200">
                        {{$t('store.code')}}
                      </th>
                      <th scope="col" class="thead-th">
                        {{$t('store.name_half')}}
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in dataFirstSecond.first_layers" :key="index">
                      <td class="text-center" v-if="outlet_config.config.show_menu_control_half_half">
                            <span>
                              <b-form-checkbox class="checkbox-warning" v-model="dataFirstSecond.first_layers[index].value" value="1" unchecked-value="0"></b-form-checkbox>
                            </span>
                      </td>
                      <td>
                        <span>{{item.sku}}</span>
                      </td>
                      <td>
                        <span>{{item.name[$session.get('lang')]}}</span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </b-collapse>
              </b-card>
              <div class="clear-both"></div>
              <b-card header-tag="header" footer-tag="footer" class="col-sm-6" style="padding: 0">
                <div slot="header">
                  <i className="fa fa-align-justify"></i><strong>{{ $t('store.crust_half') }}</strong>
                  <label class="switch switch-sm switch-text switch-info float-right"
                         @click="updateSecondInformationStatus" v-b-toggle.second_information_content>
                    <i class="fa fa-sort-down" v-if="secondInformationStatus"></i>
                    <i class="fa fa-sort-up" v-if="!secondInformationStatus"></i>
                  </label>
                </div>
                <b-collapse :visible.sync="secondInformationStatus" id="second_information_content">
                  <table class="table table-striped table-hover table-sm header-pointer">
                    <thead class="table-thead">
                    <tr>
                      <th class="thead-th" width="100" v-if="outlet_config.config.show_menu_control_half_half">
                        {{$t('store.exclusion_target')}}
                      </th>
                      <th scope="col" class="thead-th" width="200">
                        {{$t('store.code')}}
                      </th>
                      <th scope="col" class="thead-th">
                        {{$t('store.name_half')}}
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in dataFirstSecond.second_layers" :key="index">
                      <td class="text-center" v-if="outlet_config.config.show_menu_control_half_half">
                            <span>
                              <b-form-checkbox class="checkbox-warning" v-model="dataFirstSecond.second_layers[index].value" value="1" unchecked-value="0"></b-form-checkbox>
                            </span>
                      </td>
                      <td>
                        <span>{{item.sku}}</span>
                      </td>
                      <td>
                        <span>{{item.name[$session.get('lang')]}}</span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </b-collapse>
              </b-card>
              <div class="clear-both"></div>
            </div>
          </div>
          <div style="padding: 0px 15px;" v-show="!checkPermission($auth.user(),'hide-business-hours-store')" v-if="checkPermissionAdmin($auth.user(), 'get.v1.product-menu-be.list_half_firsts_and_seconds')">
            <div class="row">
              <b-card header-tag="header" footer-tag="footer" class="col-sm-6" style="padding: 0">
                <div slot="header">
                  <i className="fa fa-align-justify"></i><strong>{{$t('store.applicable_coupons') }}</strong>
                  <label class="switch switch-sm switch-text switch-info float-right"
                         @click="updateApplicableCouponStatus" v-b-toggle.applicable_coupon_status>
                    <i class="fa fa-sort-down" v-if="applicableCouponStatus"></i>
                    <i class="fa fa-sort-up" v-if="!applicableCouponStatus"></i>
                  </label>
                </div>
                <b-collapse :visible.sync="applicableCouponStatus" id="applicable_coupon_status">
                  <b-form class="row">
                    <b-col cols="12">
                      <div class="table-responsive outlet-data">
                        <table class="table table-striped table-hover table-sm header-pointer">
                          <thead>
                          <tr>
                            <th scope="col" v-for="item in couponDataTable.fields" :key="item.id"
                                @click="updateSort(item.name)">
                              <i class="fa fa-sort-amount-asc text-muted"
                                 v-if="couponDataTable.sort.type == 'asc' && couponDataTable.sort.field == item.name"></i>
                              <i class="fa fa-sort-amount-desc text-muted"
                                 v-if="couponDataTable.sort.type == 'desc' && couponDataTable.sort.field == item.name"></i>
                              <span v-if="item.label != null">{{$t('store.'+item.label)}}</span>
                              <span v-if="item.label == null">{{$t('store.'+item.name)}}</span>
                            </th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-if="couponDataTable.items.length == 0">
                            <td class="text-center" :colspan="couponDataTable.fields.length + 2">
                              {{$t('message.no_data')}}
                            </td>
                          </tr>
                          <tr v-for="item in couponDataTable.items" :key="item.id">
                            <td scope="row" v-for="field in couponDataTable.fields" :key="field.id">
                              <span v-if="field.render != null"
                                    v-html="field.render(item[field.name=='coupon_code'?'code':'name'], item)"></span>
                              <span v-if="field.render == null">
                            {{item[field.name]}}
                          </span>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <b-row>
                        <b-col>
                          <b-pagination :total-rows="couponDataTable.total" :per-page="couponDataTable.perPage"
                                        v-model="couponDataTable.currentPage"/>
                        </b-col>
                        <b-col col lg="1">
                          <b-form-select v-model="couponDataTable.perPage" :options="[10, 20, 50, 100]" class="mb-3"/>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-form>
                </b-collapse>
              </b-card>

              <b-card header-tag="header" v-if="typeof this.$route.params.uuid !== 'undefined'" footer-tag="footer"
                      class="col-sm-6" style="padding: 0">
                <div slot="header">
                  <i className="fa fa-align-justify"></i><strong>{{ $t('store.store_group') }}</strong>
                  <label class="switch switch-sm switch-text switch-info float-right"
                         @click="updateStoreGroupInformationStatus" v-b-toggle.store_group_information_content>
                    <i class="fa fa-sort-down" v-if="storeGroupInformationStatus"></i>
                    <i class="fa fa-sort-up" v-else></i>
                  </label>
                </div>
                <b-collapse :visible.sync="storeGroupInformationStatus" id="store_group_information_content">
                  <table class="table table-striped table-hover table-sm header-pointer">
                    <tr v-if="outlet_groups.length <= 0">
                      <td class="text-center" colspan="3">
                        {{$t('message.no_data')}}
                      </td>
                    </tr>
                    <tr v-for="(_group, index) in outlet_groups" :key="index" v-if="(assertEnableOnlyActivatedStore() && _group.active) || !assertEnableOnlyActivatedStore()">
                      <td>
                        <router-link :to="{name:'store_group_edit' ,params: {uuid: _group.uuid}}" v-show="!checkPermission($auth.user(),'rgm-role-editable')">
                          {{_group.name[$session.get('lang')]}}
                        </router-link>
                        <span v-show="checkPermission($auth.user(),'rgm-role-editable')">
                          {{_group.name[$session.get('lang')]}}
                        </span>
                      </td>
                    </tr>
                  </table>
                </b-collapse>
              </b-card>
            </div>
          </div>
          <div class="clear-both"></div>
        </b-col>

      </b-row>
    </div>
    <!-- New Map -->
    <b-modal ref="newMap" v-bind:title="$t('store.draw_map')" size="lg" body-class="padding-none" :hide-header="false" hide-header-close no-close-on-esc no-close-on-backdrop
             :hide-footer="true">
      <outlet-map v-bind:lat="item.lat" v-bind:long="item.long" v-bind:markers="markers" @paths="paths = $event" v-bind:outlet="item"
                  v-bind:getpaths="paths"></outlet-map>
    </b-modal>
    <!-- End New map -->
    <!-- Notification for add address -->
    <b-modal ref="notiMap" v-bind:title="$t('store.noti_draw_map')" size="lg">
      {{$t('store.noti_draw_map')}}
    </b-modal>
    <!--  -->
    <!-- Show calendar -->
    <b-modal v-if="this.$route.params.uuid" ref="calendar" id="calendar_modal" hide-footer v-bind:title="$t('store.calendar')" class="modal-dialog">
      <calendar v-if="this.$route.params.uuid" v-model="calendarData" mode="month" :submitting="calendarSaving" @change="saveCalendar"></calendar>
    </b-modal>
    <b-modal v-if="!this.$route.params.uuid" ref="calendar" hide-footer v-bind:title="$t('store.notification')">
      <p class="calendar-notification">{{$t('store.calendar_setting_notification')}}</p>
    </b-modal>
  </div>
</template>

<style>
  .store-form .btn-secondary {
    border-radius: 3px;
  }
  #calendar_modal .modal-dialog {
    max-width: 100%;
    margin: 1.75rem auto;
  }
  @media (min-width: 1024px) {
    #calendar_modal .modal-dialog {
      max-width: 90%;
      margin: 1.75rem auto;
    }
  }
  /*checkbox style*/
  .store-form .form-check:after,
  .store-form .form-check:before {
    content: " ";
    display: table;
    content: "";
    line-height: 0;
  }
  .store-form .form-check input[type="checkbox"] {
    opacity: 0;
    z-index: 1;
    cursor: pointer;
  }
  .store-form .form-check label {
    min-height: 20px;
    padding-left: 15px;
    cursor: pointer;
    display: inline-block;
    max-width: 100%;
    margin-bottom: 5px;
    font-weight: normal;
    vertical-align: middle;
    position: relative;
  }
  .store-form .form-check label::before {
    border-radius: 50%;
    content: "";
    display: inline-block;
    position: absolute;
    width: 20px;
    height: 20px;
    left: 0;
    margin-left: -10px;
    border: 1px solid #cccccc;
    background-color: #fff;
    -webkit-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
    -o-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
    transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
  }
  .store-form .form-check input[type="checkbox"]:checked + label::before {
    background-color: #0086FF;
    border-color: #0086FF;
  }
  .store-form .form-check input[type="checkbox"]:checked + label::after {
    font-family: 'FontAwesome';
    content: "\f00c";
    color: #fff;
  }
  .store-form .form-check label::after {
    display: inline-block;
    position: absolute;
    width: 16px;
    height: 16px;
    left: 0;
    top: 0;
    margin-left: -10px;
    padding-left: 4px;
    padding-top: 1px;
    font-size: 12px;
    color: #0086FF;
  }
  /*checkbox style*/
  .store-form #customize-field .col-sm-10 {
    padding-left: 8px;
  }
  .store-form .form-check-inline {
    margin-right: 1rem;
  }
  .store-form .modal-lg {
    max-width: 95%;
    margin-top: 0;
  }
  .store-form .modal-body {
    padding: 0 1rem;
  }
  .store-form .padding-none {
    padding: 0;
  }
  .time-service-to-border .mx-datepicker-popup {
    left: 0 !important;
  }
  .border-red {
    border-color: red;
  }
</style>

<style scoped>
  /*input file */
  .file-select > .select-button {
    padding: 7px;
    color: white;
    border-radius: .2rem;
    text-align: center;
    font-weight: bold;
    background: #0086FF !important;
    border-color: #0086FF !important;
    cursor: pointer;
    margin-top: 5px;
  }
  .file-select > input[type="file"] {
    display: none;
  }
  /*input file*/
  .store-form .btn-save {
    float: right;
    margin-right: 22px;
  }
  .store-form .depositions .label {
    flex: none;
    width: auto;
    padding-right: 5px;
    text-align: right;
  }
  .store-form .depositions .label-collection,
  .store-form .depositions .label-restaurant {
    flex: 0 0 8%;
    padding-right: 5px;
    padding-left: 0;
    text-align: right;
  }
  .store-form .depositions .switch.switch-icon {
    margin-right: 10px;
  }
  .disabled {
    color: darkgrey;
  }
  .text-center .btn-success {
    float: right;
    margin-right: 303px;
  }
  .fa-plus:before {
    padding-left: 2px;
  }
  .remark-row {
    display: flex;
    margin-bottom: 10px;
  }
  .store-form .add-more,
  .store-form .view-calendar {
    padding-left: 0;
  }
  .business-hours {
    background: #fff;
    padding: 5px;
    border: 1px solid gray;
  }
  .gray-background .form-control {
    padding: 8px;
    border: 1px solid gray;
  }
  .gray-background {
    background: #F4F6F8;
    padding: 15px;
  }
  .gray-background .row {
    margin-bottom: 20px;
  }
  .remark .btn-danger {
    margin-top: 7px;
    background-color: #fff;
  }
  .gray-background .btn-danger {
    margin-top: 7px;
    background-color: #F4F6F8;
  }
  .gray-background .btn-danger .fa,
  .remark .btn-danger .fa {
    color: #0086FF;
    font-size: 20px;
  }
  .clear-both {
    margin-bottom: 15px;
  }
  .card {
    margin-bottom: 0;
  }
  /*div.card:last-child{
    margin-bottom: 1.5rem;
  }*/
  .store-form .draw-map {
    width: 100%;
  }
  .store-form .card-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }
  .store-form .switch.switch-icon {
    margin-top: 5px;
  }
  .store-form .header-custom {
    margin-top: 15px;
  }
  .store-form .header-custom-switch {
    margin-top: 5px;
    margin-bottom: 0;
  }
  .store-form .header-custom-switch .uppercase {
    display: inline-flex;
  }
  .store-form .header-custom-switch .col-form-label {
    text-align: right;
  }
  .store-form .header-custom-switch .active {
    float: right;
  }
  .store-form div.header,
  .store-form .header .card-header {
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }
  .store-form .space {
    margin-right: 20px;
  }
  .store-form .custom-form-group-2,
  .store-form .custom-form-group .col-sm-9,
  .store-form .custom-form-group .col-sm-10 {
    display: inline-flex !important;
  }
  .store-form .preview-image {
    width: 100%;
  }
  .store-form .timeline {
    margin-top: 30px;
    padding-left: 15px;
    padding-right: 15px;
  }
  .store-form .points {
    width: 100%;
    height: 30px;
    font-size: 30px;
    position: relative;
    z-index: 1;
  }
  .store-form .points i {
    position: absolute;
  }
  .store-form .step-commit {
    margin-left: calc(0% - 10px);
  }
  .store-form .step-updated {
    margin-left: calc(33% - 15px);
  }
  .store-form .step-publishing {
    margin-left: calc(66% - 15px);
  }
  .store-form .step-publish {
    margin-left: calc(100% - 20px);
  }
  .store-form .line-1 {
    position: absolute;
    margin-left: 15px;
    width: calc(33% - 30px);
    height: 1px;
    border: 1px solid #4dbd74 !important;
    margin-top: 15px;
    z-index: 0;
  }
  .store-form .line-2 {
    position: absolute;
    margin-left: calc(33% + 15px);
    width: calc(33% - 30px);
    height: 1px;
    border: 1px solid #4dbd74 !important;
    margin-top: 15px;
    z-index: 0;
  }
  .store-form .line-3 {
    position: absolute;
    margin-left: calc(66% + 15px);
    width: calc(33% - 30px);
    height: 1px;
    border: 1px solid #4dbd74 !important;
    margin-top: 15px;
    z-index: 0;
  }
  .store-form .current-point {
    font-size: 30px;
  }
  .store-form .img-min-height {
    min-height: 161px;
  }
  .store-form .custom-checkbox {
    padding-left: 0px;
  }
  .calendar-notification {
    margin-top: 10px;
    color: red;
  }
  .store-form .box-export-tradezone {
    display: inline-block;
  }
  .store-form .box-export-tradezone .export-tradezone {
    height: 33px;
    margin-bottom: 4px; 
    border-radius: 0.2rem;
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
  import {validationMixin} from 'vuelidate'
  import {required, email, requiredIf} from 'vuelidate/lib/validators'
  import cSwitch from '../../../components/Switch'
  import cSwitchCustom from '../../../components/SwitchCustom'
  import vSelect from 'vue-select'
  import MaskedInput from 'vue-text-mask'
  import CustomizeField from '../../../components/Partials/CustomizeField'
  import Tables from '../../tables/Tables'
  import OutletMap from './OutletsMap.vue'
  import Calendar from '../../../components/Partials/Calendar'
  import moment from 'moment'
  import axios from 'axios'
  import Multiselect from 'vue-multiselect'
  import DatePickerInput from '@/components/Partials/DatePickerInput'

  const CancelToken = axios.CancelToken
  let cancel = null
  let vm = null
  let defaultOpeningDate = '1970-01-01';
  const UberEats = 'uber-eats';
  export default {
    name: 'OutletForm',
    props: {
      id: {
        type: String,
        required: false
      }
    },
    components: {
      Multiselect,
      Tables,
      cSwitch,
      cSwitchCustom,
      vSelect,
      MaskedInput,
      CustomizeField,
      OutletMap,
      Calendar,
      DatePickerInput
    },
    data: function () {
      return {
        clientId: '',
        current_timezone: { time_zone:this.$moment.tz.guess() },
        aggregators_data: {},
        outlet_config: {},
        calendarData: {
          special_date_open: [],
          special_date_close: [],
          huts_day: [],
          public_holiday: [],
          order_duration: []
        },
        updateCustomizeField: false,
        dates: ['common.mon', 'common.tue', 'common.wed', 'common.thu', 'common.fri', 'common.sat', 'common.sun', 'store.public_holiday'],
        // outlet: this.$store.getters.config.gms.outlet,
        delivery: 1,
        collection: 1,
        restaurant: 1,
        min_d: 0,
        min_c: 0,
        min_r: 0,
        quotetime_d: 0,
        quotetime_c: 0,
        quotetime_r: 0,
        imageData: {},
        outlet_groups: [],
        outlet_payment_methods: [],
        payment_accepted: {},
        order_types: [],
        serviceFee: {
          active: false,
          price: 0,
          time_apply: {
            from: '00:00',
            to: '23:59'
          },
          name: {
            en: '',
            ja: ''
          }
        },
        item: {
          outletId: 0,
          client_id: 0,
          email: '',
          name: {},
          description: {},
          code: '',
          code_validate: "",
          lat: null,
          long: null,
          area_code: 'BC1110',
          jpchar: '',
          owner_code: '',
          owner_name: '',
          remarks: [],
          lunchTimeHours: [],
          businessHours: [],
          active: 0,
          disposition: [],
          min_cart: {'D': 0, 'C': 0, 'E': 0},
          quote_time: {'D': 30, 'C': 20, 'E': 0},
          customize: {},
          from_date: this.today(),
          to_date: this.$moment(new Date()).add(10, 'y').format('DD/MM/YYYY'),
          tradezone: [],
          delivery_fee: 0,
          street: '',
          address: {},
          phone: '',
          fax: '',
          offline_orders: 1,
          online_orders: 1,
          tier: 1,
          alcohol_drinks_available: 0,
          refurbishment: 0,
          tax_fee: 0,
          payment_accepted: {},
          time_zones: [],
          duration: this.$const.INTERVAL_TIME[this.$store.getters.config.base.id],
          pos_ip: null,
          gst_number: null,
          merchant_payment_click_id:'',
          old_merchant_id: '',
          old_code: ''
        },
        basicInformationStatus: true,
        paymentInformationStatus: true,
        aggregatorsStatus: true,
        uberEatsStatus: true,
        timeSettingsInformationStatus: true,
        firstInformationStatus: true,
        secondInformationStatus: true,
        storeGroupInformationStatus: true,
        applicableCouponStatus: true,
        payment_method: [],
        aggregators: this.$store.getters.config.gms.base.aggregators != null ? this.$store.getters.config.gms.base.aggregators : [],
        lat: 0,
        long: 0,
        center: {lat: 0, lng: 0},
        markers: [{
          position: {lat: 0, lng: 0},
          label: '',
          draggable: false,
          title: ''
        }],
        infoContent: '',
        infoLink: '',
        infoWindowPos: {
          lat: 0,
          lng: 0
        },
        infoWinOpen: false,
        currentMidx: null,
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35
          }
        },
        paths: [],
        edited: [],
        special_dates: [],
        advance_hours: [],
        estimateTime: {
          D: [],
          C: []
        },
        intervalTime: {
          D: [],
          C: []
        },
        dataFirstSecond: {
          first_layers: [],
          second_layers: []
        },
        couponDataTable: {
          items: [],
          fields: [
            {
              name: 'coupon_code',
              filter: true,
              sort: true,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data
              }
            },
            {
              name: 'coupon_name',
              filter: true,
              sort: true,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data[this.$session.get('lang')]
              }
            }
          ],
          sort: {
            field: 'code',
            type: 'desc'
          },
          currentPage: 1,
          total: 0,
          perPage: 20,
          source: null
        },
        calendarSaving: false,
        disableSaveAfterClick: false,
        isShowPublishButton: false
      }
    },
    mixins: [
      validationMixin
    ],
    validations: {
      item: {
        // email: {
        //   required: requiredIf(function (nestedModel) {
        //     if (typeof this.$route.params.uuid !== 'undefined') {
        //       return true
        //     }
        //   }),
        //   email
        // },
        code: {
          required: requiredIf(function (nestedModel) {
            if (typeof this.$route.params.uuid !== 'undefined') {
              return true
            }
          })
        },
        lat: {
          required: requiredIf(function (nestedModel) {
            if (typeof this.$route.params.uuid !== 'undefined') {
              return true
            }
          })
        },
        long: {
          required: requiredIf(function (nestedModel) {
            if (typeof this.$route.params.uuid !== 'undefined') {
              return true
            }
          })
        },
      }
    },
    mounted () {
      let country_code = this.$store.getters.config.country_code
      var autocomplete = new google.maps.places.Autocomplete(
        (document.getElementById('autocomplete')), {componentRestrictions: {country: country_code}}
      )
      autocomplete.setFields(['formatted_address', 'geometry'])
      autocomplete.addListener('place_changed', () => {
        let place = autocomplete.getPlace()
        this.item.lat = place.geometry.location.lat()
        this.item.long = place.geometry.location.lng()
        this.item.street = place.formatted_address
      })
      this.$root.$on('paths', (paths) => {
        this.updateEdited(paths)
      })
      this.$root.$on('updatePathsMap',(updatePaths) => {
        this.updatePathsMap(updatePaths)
      })
      this.$root.$on('closeMap',() => {
        this.closeMap()
      })
    },
    methods: {
      showPopupConfirm() {
        if (localStorage.getItem('clientID') === vm.client_uuid.jp) {
          if (this.item.active === 0) {
            let options = {
              html: true,
              okText: vm.$t('common.ok'),
              cancelText: vm.$t('common.cancel')
            }
            vm.$dialog.confirm(vm.$t('message_turn_off_store'), options)
            .then(function (dialog) {
              vm.item.active = 0
            }).catch(function () {
              vm.item.active = 1
            })
          }
        }
      },
      updateAggregators (value, item) {
        this.aggregators_data[item] = value
        vm.$set(vm.aggregators_data, item, value)
      },
      checkShowPublishButton() {
        let getCache = vm.getCacheLocalStorage(vm.item.code + '_' + 'pushlish')
        vm.isShowPublishButton = true
        if (!getCache.expired) {
          vm.isShowPublishButton = false
        }
      },
      assertEnableOnlyActivatedStore() {
        const config = JSON.parse(JSON.stringify(this.$store.getters.config.manual_config))
        return config
          && config.enable_filter_only_active_store
          && config.enable_filter_only_active_store == 1
      },
      uploadKmlFile (event) {
        let input = event.target
        vm.$bus.$emit('loading', 'block')
        if (input.files && input.files[0]) {
          let formData = new FormData()
          formData.append('file', input.files[0])
          let config = {headers: {'Content-Type': 'multipart/form-data'}}
          //call an API to save csv file
          vm.axios.outlet.importKML(formData, config, function (response) {
            vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
            vm.$bus.$emit('loading', 'none')
          }, function () {
            vm.$toastr.error(vm.$t('message.error'), vm.$t('message.success'), {})
            vm.$bus.$emit('loading', 'none')
          })
        }
      },
      checkConfig: function (key, value, category) {
        this.outlet_config = this.$store.getters.config.gms.outlet
        
        let vm = this
        if (typeof this.$route.params.uuid === 'undefined') {
          if (category === 'show') {
            return true
          } else {
            return false
          }
        }
        if (typeof vm.outlet_config[key] !== 'undefined') {
          let result = vm.outlet_config[key].filter(obj => {
            return obj.type === value
          })
          if (typeof result[0] !== 'undefined') {
            return result[0][category]
          }
        }
      },
      checkDateRange (value) {
        return this.dates.indexOf(value) > -1 ? true : false
      },
      updateBasicInformationStatus () {
        this.basicInformationStatus = this.basicInformationStatus ? false : true
      },
      updateApplicableCouponStatus () {
        this.applicableCouponStatus = this.applicableCouponStatus ? false : true
      },
      updatePaymentInformationStatus () {
        this.paymentInformationStatus = this.paymentInformationStatus ? false : true
      },
      updateAggregatorsStatus () {
        this.aggregatorsStatus = this.aggregatorsStatus ? false : true
      },
      updateUberEatsStatus () {
        this.uberEatsStatus = this.uberEatsStatus ? false : true
      },
      checkUberEats(item) {
        if (item !== null) {
          return item == UberEats;
        }
        return this.aggregators_data.hasOwnProperty(UberEats);
      },
      updateTimeSettingsInformationStatus () {
        this.timeSettingsInformationStatus = this.timeSettingsInformationStatus ? false : true
      },
      updateFirstInformationStatus () {
        this.firstInformationStatus = this.firstInformationStatus ? false : true
      },
      updateSecondInformationStatus () {
        this.secondInformationStatus = this.secondInformationStatus ? false : true
      },
      updateStoreGroupInformationStatus () {
        this.storeGroupInformationStatus = this.storeGroupInformationStatus ? false : true
      },
      nameState: function (lang) {
        let currentLang = this.$session.get('lang')
        if (typeof this.$route.params.uuid === 'undefined') {
          return true
        }
        if (currentLang == lang) {
          if (this.item.name[lang] != undefined && this.item.name[lang] && this.item.name[lang] != '') {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      },
      stateService(value) {
        let langs = this.$store.getters.languages
        let checkName = {}
        if (typeof value === 'object') {
          for (let index = 0; index < langs.length; index++) {
            const element = langs[index];
            if ( value[element] != undefined && value[element] && value[element] != '') {
              checkName[element] = true
            } else {
              checkName[element] = false
            }
          }
          if (Object.values(checkName).indexOf(false) > -1) {
            return false
          }
          return true
        } else {
          if(value && parseInt(value) > 0) {
            return true
          }
        }
        return false
      },
      checkTimeService(isfrom) {
        let from = this.sumNumberTime(this.serviceFee.time_apply.from.split(':')) 
        let to = this.sumNumberTime(this.serviceFee.time_apply.to.split(':'))
        let classTimeFrom = document.getElementsByClassName('time-service-from-border')
        let classTimeTo = document.getElementsByClassName('time-service-to-border')

        if (from == to) {
          classTimeFrom[0].classList.add('border-red')
          classTimeTo[0].classList.add('border-red')
          return false
        }

        if(from > to && isfrom) {
          classTimeFrom[0].classList.add('border-red')
          if(classTimeTo.length > 0) {
            classTimeTo[0].classList.remove('border-red')
          }
          return false
        } else if(from > to && !isfrom) {
          classTimeTo[0].classList.add('border-red')
          if(classTimeFrom.length > 0) {
            classTimeFrom[0].classList.remove('border-red')
          }
          return false
        } else {
          if(classTimeTo.length > 0) {
            classTimeTo[0].classList.remove('border-red')
          }
          if(classTimeFrom.length > 0) {
            classTimeFrom[0].classList.remove('border-red')
          }
          return true
        }
      },
      sumNumberTime(arr) {
        return parseInt(arr[0])*60 + parseInt(arr[1])
      },
      checkSubmit: function () {
        let langs = this.$store.getters.languages
        let validateName = false
        for (let l in langs) {
          if (this.item.name[langs[l]] == '') {
            validateName = true
          }
        }
        let form = this.$v.item.$invalid
        return form || validateName || this.disableSaveAfterClick
      },
      manageTradezone: function() {
        let uuid = this.$route.params.uuid;
        this.$router.push({name: 'tradezone_list', params: { uuid: uuid }})
      },
      removeRemark (index) {
        this.item.remarks.splice(index, 1)
      },
      addRemark () {
        this.item.remarks.push({})
      },
      openCalendar () {
        this.$refs.calendar.show()
      },
      /**
       * Convert formate date
       */
      convertDateFormat (val) {
        val = this.convertUTCToClientTime(val)
        return this.$moment(val, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY HH:mm:ss')
      },
      revertDateFormat (val) {
        let formatDate = this.$moment(val, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
        return this.convertDateTimeToUTC(formatDate)
      },
      revertBaseDateFormat(val){
        return this.$moment(val, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
      },
      convertDateFormatNotDay (datetime) {
        if (!datetime) {
          return ''
        }
        return moment.utc(datetime).local().format('HH:mm:ss')
      },
      showButtonExportTradezone: function() {
        if (this.$route.name == 'outlets_edit') return true
        return false
      },
      exportTradezone: function() {
        if (vm.$route.params.uuid) vm.axios.outlet.exportTradezone(vm.$route.params.uuid)
      },
      /**
       * Open Map from another file
       */
      openMap: function () {
        if (this.item.lat !== null && this.item.long !== null) {
          this.$refs.newMap.show()
          this.$root.$emit('bv::show::modal')
        } else {
          this.$refs.notiMap.show()
        }
      },
      /**
       * Open Map from another file
       */
      closeMap: function (bvModalEvt) {
        if (this.item.lat !== null && this.item.long !== null) {
          const options = {
            html: true,
            okText: this.$t('common.yes'),
            cancelText: this.$t('common.cancel'),
            okVariant: 'success',
          }
          this.$dialog.confirm(this.$t('message.delete_confirm'), options)
            .then(() => {
              this.$refs.newMap.hide()
            })
            .catch((error) => {
              console.log('close error', error);
            })
        } else {
          this.$refs.notiMap.hide()
        }
      },
      /**
       * Get Place when put address
       */
      setPlace: function (place) {
        this.item.lat = place.geometry.location.lat()
        this.item.long = place.geometry.location.lng()
        this.item.address = place.formatted_address
      },
      toggleInfoWindow: function (marker, idx) {
        this.infoWindowPos = marker.position
        this.infoContent = marker.title
        this.infoLink = marker.www
        // check if its the same marker that was selected if yes toggle
        if (this.currentMidx === idx) {
          this.infoWinOpen = !this.infoWinOpen
        } else {
          // if different marker set infowindow to open and reset current marker index
          this.currentMidx = idx
          this.infoWinOpen = true
        }
      },
      updatePathsMap(mvcArray) {
        this.paths = [...mvcArray];
      },
      updateEdited (mvcArray) {
        if (mvcArray.length !== 0) this.paths = [...mvcArray];
      },
      pushMenuForOutlets () {
        let data = {}
        let notiMessSuccess = this.$t('message.update_successful')
        let notiTitleSuccess = this.$t('message.success')
        data.scope = 'all'
        data.bulk = []
        data.outlet = {}
        data.outlet.uuid = this.$route.params.uuid
        data.outlet.code = this.item.code

        if(!data.outlet.uuid || !data.outlet.code) {
          vm.$toastr.error(vm.$t('error_message.error_message_data_invalid'), {})
          return
        }
        this.axios.outlet.publishCombo(data,
          function (response) {
            vm.$toastr.success(notiMessSuccess, notiTitleSuccess, {})
          })
        this.axios.outlet.publishMenu(data,
          function (response) {
            vm.$toastr.success(notiMessSuccess, notiTitleSuccess, {})
          })
        
        vm.isShowPublishButton = true
        if (vm.$store.getters.config.gms.outlet.config.show_push_to_prod) {
          vm.isShowPublishButton = false
          let time = Number(vm.$store.getters.config.manual_config.set_time_show_button_push_to_prod_store)
          time = Number.isNaN(time) ? 5 : time 
          vm.setCacheLocalStorage(  data.outlet.code + '_' + 'pushlish', true, time )
        }
        
      },
      /**
       * Save outlet
       */
      saveOutlet () {
        this.disableSaveAfterClick = true;
        var name = {}
        var des = {}
        var address = {}
        var disposition = []
        var customize = {}
        var mincart = {D: parseInt(this.item.min_cart.D) || 0, C: parseInt(this.item.min_cart.C) || 0} // Keep data of min_cart
        var quotetime = {D: parseInt(this.item.quote_time.D) || 0, C: parseInt(this.item.quote_time.C) || 0}// Keep data of quote_time
        var duration = {D: parseInt(this.item.duration.D) || this.$const.INTERVAL_TIME[this.$store.getters.config.base.id].D, C: parseInt(this.item.duration.C) || this.$const.INTERVAL_TIME[this.$store.getters.config.base.id].C}// Keep data of quote_time
        var division = this.item.division || {}
        var notiMessSuccess = this.$t('message.update_successful')
        var notiMessCreateSuccess = this.$t('message.create_successful')
        var notiTitleSuccess = this.$t('message.success')
        var notiTitleError = this.$t('message.error')
        let todayNew = vm.$moment(new Date()).format('YYYY-MM-DD')
        for (let l in this.$store.getters.languages) {
          name[this.$store.getters.languages[l]] = this.item.name[this.$store.getters.languages[l]]
          des[this.$store.getters.languages[l]] = this.item.description[this.$store.getters.languages[l]]
          address[this.$store.getters.languages[l]] = this.item.address[this.$store.getters.languages[l]]
        }
        if (this.delivery) {
          disposition.push('D')
        }
        if (this.collection) {
          disposition.push('C')
        }
        if (this.restaurant && this.outlet_config.config.restaurant) {
          disposition.push('R')
        }
        // customize = {
        //   'remarks': this.item.remarks
        // }
        /*============== Keep data of min_cart and quote_time, just process based on disposition ==============*/
        for (var d in disposition) {
          //mincart[disposition[d]] = this.item.min_cart[disposition[d]]
          if (this.item.quote_time[disposition[d]] == -1) {
            if (disposition[d].toUpperCase() == 'D') {
              //quotetime[disposition[d]] = this.quotetime_d
              division.D = 2
            } else if (disposition[d].toUpperCase() == 'C') {
              //quotetime[disposition[d]] = this.quotetime_c
              division.C = 2
            } else {
              //quotetime[disposition[d]] = this.quotetime_r
              division.R = 2
            }
          } else {
            //quotetime[disposition[d]] = this.item.quote_time[disposition[d]]
            if (disposition[d].toUpperCase() == 'D') {
              division.D = 1
            } else if (disposition[d].toUpperCase() == 'C') {
              division.C = 1
            } else {
              division.R = 1
            }
          }
        }
        let storeAggregator = []
        for (let i in this.aggregators_data) {
          if (this.aggregators_data[i] == 1) {
            storeAggregator.push(i)
          }
        }
        let fields = vm.outlet_config.fields
        for (let i = 0; i < fields.length; i++) {
          let field = fields[i]
          for (let j in field.body) {
            if (field.body[j].name == 'sale_from' || field.body[j].name == 'sale_to') {
              customize[field.body[j].name] = vm.revertDateFormat(vm.item[field.body[j].name])
            } else {
              customize[field.body[j].name] = vm.item[field.body[j].name]
            }
          }
        }
        let from_date = ''
        let to_date = ''

        if(this.current_timezone && this.current_timezone.time_zone){
          from_date = vm.checkDSTTime(vm.revertBaseDateFormat(vm.item.from_date),vm.current_timezone.time_zone) ? vm.convertDateTimeFromTimezoneToUTC(vm.revertBaseDateFormat(vm.item.from_date),vm.current_timezone.time_zone).subtract(1,'hours').format('YYYY-MM-DD HH:mm:ss') : vm.convertDateTimeFromTimezoneToUTC(vm.revertBaseDateFormat(vm.item.from_date),vm.current_timezone.time_zone).format('YYYY-MM-DD HH:mm:ss')
          to_date = vm.checkDSTTime(vm.revertBaseDateFormat(vm.item.to_date),vm.current_timezone.time_zone) ? vm.convertDateTimeFromTimezoneToUTC(vm.revertBaseDateFormat(vm.item.to_date),vm.current_timezone.time_zone).subtract(1,'hours').format('YYYY-MM-DD HH:mm:ss') : vm.convertDateTimeFromTimezoneToUTC(vm.revertBaseDateFormat(vm.item.to_date),vm.current_timezone.time_zone).format('YYYY-MM-DD HH:mm:ss')
        }else{
          from_date: vm.revertDateFormat(vm.item.from_date)
          to_date: vm.revertDateFormat(vm.item.to_date)
        }
        
        let obj = {}
        if(vm.outlet_config.config.service_fee && vm.serviceFee && vm.serviceFee.active) {
          if(vm.stateService(vm.serviceFee.name) && vm.stateService(vm.serviceFee.price) && vm.checkTimeService()){
            let date = moment().format('YYYY-MM-DD')
            let dateTimeServiceFeeFrom = moment(date + ' ' + vm.serviceFee.time_apply.from)
            let dateTimeServiceFeeTo = moment(date + ' ' + vm.serviceFee.time_apply.to)
            let serviceFeeFrom = ''
            let serviceFeeTo =''
            if(this.current_timezone && this.current_timezone.time_zone){
              serviceFeeFrom = vm.checkDSTTime(vm.revertBaseDateFormat(dateTimeServiceFeeFrom),vm.current_timezone.time_zone) ? vm.convertDateTimeFromTimezoneToUTC(vm.revertBaseDateFormat(dateTimeServiceFeeFrom),vm.current_timezone.time_zone).subtract(1,'hours').format('HH:mm') : vm.convertDateTimeFromTimezoneToUTC(vm.revertBaseDateFormat(dateTimeServiceFeeFrom),vm.current_timezone.time_zone).format('HH:mm')
              serviceFeeTo = vm.checkDSTTime(vm.revertBaseDateFormat(dateTimeServiceFeeTo),vm.current_timezone.time_zone) ? vm.convertDateTimeFromTimezoneToUTC(vm.revertBaseDateFormat(dateTimeServiceFeeTo),vm.current_timezone.time_zone).subtract(1,'hours').format('HH:mm') : vm.convertDateTimeFromTimezoneToUTC(vm.revertBaseDateFormat(dateTimeServiceFeeTo),vm.current_timezone.time_zone).format('HH:mm')
            } else {
              serviceFeeFrom = vm.revertDateFormat(dateTimeServiceFeeFrom).format('HH:mm')
              serviceFeeTo = vm.revertDateFormat(dateTimeServiceFeeTo).format('HH:mm')
            }
            obj = {from:serviceFeeFrom,to:serviceFeeTo}
          } else {
            vm.$toastr.error(vm.$t('message.service_fee_error'))
            this.disableSaveAfterClick = false;
            return
          }
        }
        
        var item = {
          id: this.item.id,
          name: name,
          phone: this.item.phone,
          active: this.item.active,
          fax: this.item.fax,
          offline_orders: 1,
          online_orders: this.item.online_orders,
          alcohol_drinks_available: this.item.alcohol_drinks_available,
          refurbishment: { status: this.item.refurbishment, date : defaultOpeningDate },
          payment_accepted: this.payment_accepted,
          code: this.item.code,
          delivery_fee: this.item.delivery_fee,
          tax_fee: this.item.tax_fee,
          aggregator_code: this.item.aggregator_code,
          aggregators: storeAggregator,
          email: this.item.email,
          lat: this.item.lat,
          long: this.item.long,
          area_code: this.item.area_code,
          owner_code: this.item.owner_code,
          owner_name: this.item.owner_name,
          jpchar: this.item.jpchar,
          disposition: disposition,
          min_cart: mincart,
          description: des,
          quote_time: quotetime,
          division: division,
          customize: customize,
          from_date: from_date,
          to_date: to_date,
          // tradezone: this.paths ? this.paths : [],
          street: this.item.street,
          address: address,
          timezone: this.current_timezone.time_zone,
          tier: this.item.tier,
          duration: duration,
          service_fee: Object.assign({}, vm.serviceFee)
        }
        if (vm.outlet_config.config.show_pos_ip_address) {
          item['pos_ip'] = vm.item.pos_ip
        }
        if (vm.outlet_config.config.show_gst_number) {
          item['gst_number'] = vm.item.gst_number
        }

        item.service_fee.time_apply = obj

        //Add is_migreted is true When UK DELCO Market
        if(localStorage.getItem('clientID') === vm.client_uuid.uk1 || localStorage.getItem('clientID') === vm.client_uuid.uk2) {
          item.is_migrated = 1
        }
        var hours = {}
        hours.open_hour = []
        for (var i = this.item.businessHours.length - 1; i >= 0; i--) {
          let row = this.item.businessHours[i]
          for (var hour in row) {
            if (hour <= 7) {
              let open_hour = {}
              open_hour.day = row[hour].proper_date
              open_hour.opening = row[8].value + ':00'
              open_hour.closing = row[9].value + ':00'
              open_hour.active = row[10].value.indexOf(row[hour].date) > -1 ? 1 : 0
              open_hour.order_type = row[11].value
              // convert to UTC
              if(vm.current_timezone && vm.current_timezone.time_zone){
                open_hour.opening = vm.checkDSTTime(todayNew + ' ' + open_hour.opening,vm.current_timezone.time_zone) ? vm.convertDateTimeFromTimezoneToUTC(todayNew + ' ' +open_hour.opening,vm.current_timezone.time_zone).add(1, 'hours').format('HH:mm:ss') : vm.convertDateTimeFromTimezoneToUTC(todayNew + ' ' + open_hour.opening,vm.current_timezone.time_zone).format('HH:mm:ss')
                open_hour.closing = vm.checkDSTTime(todayNew + ' ' + open_hour.closing,vm.current_timezone.time_zone) ? vm.convertDateTimeFromTimezoneToUTC(todayNew + ' ' +open_hour.closing,vm.current_timezone.time_zone).add(1, 'hours').format('HH:mm:ss') : vm.convertDateTimeFromTimezoneToUTC(todayNew + ' ' + open_hour.closing,vm.current_timezone.time_zone).format('HH:mm:ss')
              }else{
                open_hour.opening = this.convertDateTimeToUTCWithToday(open_hour.opening)
                open_hour.closing = this.convertDateTimeToUTCWithToday(open_hour.closing)
              }
              hours.open_hour.push(open_hour)
            }
          }
        }
        hours.lunch_time = []
        for (var i = this.item.lunchTimeHours.length - 1; i >= 0; i--) {
          let row = this.item.lunchTimeHours[i]
          for (var hour in row) {
            if (hour <= 7) {
              let lunch_time = {}
              lunch_time.day = row[hour].proper_date
              lunch_time.opening = row[8].value + ':00'
              lunch_time.closing = row[9].value + ':00'
              // convert to UTC
              if(vm.current_timezone && vm.current_timezone.time_zone){
                lunch_time.opening = vm.checkDSTTime(todayNew + ' ' + lunch_time.opening,vm.current_timezone.time_zone) ? vm.convertDateTimeFromTimezoneToUTC(todayNew + ' ' +lunch_time.opening,vm.current_timezone.time_zone).add(1, 'hours').format('HH:mm:ss') : vm.convertDateTimeFromTimezoneToUTC(todayNew + ' ' + lunch_time.opening,vm.current_timezone.time_zone).format('HH:mm:ss')
                lunch_time.closing = vm.checkDSTTime(todayNew + ' ' + lunch_time.closing,vm.current_timezone.time_zone) ? vm.convertDateTimeFromTimezoneToUTC(todayNew + ' ' +lunch_time.closing,vm.current_timezone.time_zone).add(1, 'hours').format('HH:mm:ss') : vm.convertDateTimeFromTimezoneToUTC(todayNew + ' ' + lunch_time.closing,vm.current_timezone.time_zone).format('HH:mm:ss')
              }else{
                lunch_time.opening = this.convertDateTimeToUTCWithToday(lunch_time.opening)
                lunch_time.closing = this.convertDateTimeToUTCWithToday(lunch_time.closing)
              }
              lunch_time.active = row[10].value.indexOf(row[hour].date) > -1 ? 1 : 0
              hours.lunch_time.push(lunch_time)
            }
          }
        }
        vm.$bus.$emit('loading', 'block')
        this.$Progress.start()
        if (this.$route.params.uuid) {
          this.axios.outlet.updateOutletDetail(vm.$route.params.uuid, item,
            function (response) {
              vm.$toastr.success(notiMessSuccess, notiTitleSuccess, {})
              vm.$Progress.finish()
              vm.$bus.$emit('loading', 'none')
              vm.$router.push({name: 'outlets_list'})
            })
          // update open hours
          hours.outlet_id = item.id
          vm.axios.outlet.updateOpenHours(hours)
          vm.saveMenuControlFirstSecond()
          // Update Merchant Payment Id
          if (vm.outlet_config.config.show_payment_click_id
          && (
            vm.item.code != vm.item.old_code ||
            vm.item.old_merchant_id != vm.item.merchant_payment_click_id)) {
            vm.createOrUpdateMerchantPaymentIdDetails({
              store_code: item.code,
              old_code: vm.item.old_code,
              merchant_id: vm.item.merchant_payment_click_id
            })
          }
        } else {
          this.axios.outlet.createOutlet(item,
            function (response) {
              vm.$toastr.success(notiMessCreateSuccess, notiTitleSuccess, {})
              vm.$Progress.finish()
              vm.$bus.$emit('loading', 'none')
              if (response.data.data.item.id) {
                hours.outlet_id = response.data.data.item.id
                vm.axios.outlet.createOpenHours(hours)
                vm.saveMenuControlFirstSecond()
                // Create Merchant Payment Id
                if (vm.outlet_config.config.show_payment_click_id && '' != vm.item.merchant_payment_click_id
                && (vm.item.old_merchant_id != vm.item.merchant_payment_click_id)) {
                  let store_code =  vm._.get(response.data.data.item, 'code', null)
                  if (store_code) {
                    vm.item.old_code = store_code
                    vm.createOrUpdateMerchantPaymentIdDetails({
                      store_code,
                      old_code: vm.item.old_code,
                      merchant_id: vm.item.merchant_payment_click_id
                    })
                  }
                }
                vm.$router.push({name: 'outlets_list'})
              }
            },
            function (callBackError) {
              vm.disableSaveAfterClick = false;
            })
        }
      },
      saveMenuControlFirstSecond () {
        if (this.dataFirstSecond.first_layers.length === 0
          || this.dataFirstSecond.second_layers.length === 0
          || !this.checkPermissionAdmin(this.$auth.user(), 'post.v1.product-menu-be.menu-outlets')
        ) {
          return
        }

        let data = {
          outlet_code: this.item.code,
          is_half: 1,
          layers: this.dataFirstSecond.first_layers.concat(this.dataFirstSecond.second_layers)
        }
        this.axios.menu.saveMenuControl(data)
      },
      /**
       * get today date
       */
      today () {
        return this.$moment(new Date()).format('DD/MM/YYYY')
      },
      openhours () {
        this.$refs.refOpenHours.show()
      },
      /**
       * add advance hours to list with default attribute
       */
      addAdvanceHours () {
        this.advance_hours.push({
          id: null,
          opening: '08:00:00',
          closing: '23:59:00',
          duration: {'D': 15, 'C': 15},
          date: this.$moment().format('DD-MM-YYYY')
        })
      },
      addBusinessHours () {
        let item = this.getNewDatesItem(this.item.businessHours, 'selectedBusinessHour')
        this.item.businessHours.push(item)
      },
      removeBusinessHours (index) {
        this.item.businessHours.splice(index, 1)
      },
      getNewDatesItem (item, selected) {
        let hoursFrom = '11:00'
        let hoursTo = '14:00'
        if (selected === 'selectedBusinessHour') {
          hoursFrom = '08:00'
          hoursTo = '23:00'
        }
        let data = {
          0: {'date': 'common.mon', 'proper_date': 'Mon', 'status': 0},
          1: {'date': 'common.tue', 'proper_date': 'Tue', 'status': 0},
          2: {'date': 'common.wed', 'proper_date': 'Wed', 'status': 0},
          3: {'date': 'common.thu', 'proper_date': 'Thu', 'status': 0},
          4: {'date': 'common.fri', 'proper_date': 'Fri', 'status': 0},
          5: {'date': 'common.sat', 'proper_date': 'Sat', 'status': 0},
          6: {'date': 'common.sun', 'proper_date': 'Sun', 'status': 0},
          7: {'date': 'store.public_holiday', 'proper_date': 'Pub', 'status': 0},
          8: {'date': 'store.from', 'value': hoursFrom},
          9: {'date': 'store.to', 'value': hoursTo},
          10: {'date': selected, 'value': []},
          11: {'date': 'store.order_type', 'value': '["D","C","R"]'}
        }
        return data
      },
      addLunchTimeHours () {
        let item = this.getNewDatesItem(this.item.lunchTimeHours, 'selectedLunchTimeHour')
        this.item.lunchTimeHours.push(item)
      },
      removeLunchTimeHours (index) {
        this.item.lunchTimeHours.splice(index, 1)
      },
      /**
       * remove advance hours from list
       * @param index
       */
      removeAdvanceHours (index) {
        let data = []
        for (let i in this.advance_hours) {
          if (i != index) {
            data.push(this.advance_hours[i])
          }
        }
        this.advance_hours = data
      },
      /**
       * remove special date from list
       * @param index
       */
      removeSpecialDate (index) {
        let dates = []
        for (let i in this.special_dates) {
          if (i != index) {
            dates.push(this.special_dates[i])
          }
        }
        this.special_dates = dates
      },
      /**
       * add special date to list with default attribute
       */
      addSpecialDate () {
        this.special_dates.push({
          id: null,
          name: '',
          opening: '08:00:00',
          closing: '23:59:00',
          date: this.$moment().format('DD-MM-YYYY'),
          status: 1
        })
      },
      /**
       * Get first and second data
       */
      refreshDataFirstAndSeconds () {
        if (!this.checkPermissionAdmin(this.$auth.user(), 'get.v1.product-menu-be.list_half_firsts_and_seconds')) {
          return
        }
        let data = {outlet_code: this.item.code}
        this.axios.menu.listHalfFirstAndSeconds(data,
          function (response) {
            vm.dataFirstSecond = response.data.data.items
            for (let i in vm.dataFirstSecond.first_layers) {
              vm.dataFirstSecond.first_layers[i].uuid = 'half_first_' + vm.dataFirstSecond.first_layers[i].id
            }
            for (let i in vm.dataFirstSecond.second_layers) {
              vm.dataFirstSecond.second_layers[i].uuid = 'half_second_' + vm.dataFirstSecond.second_layers[i].id
            }
          })
      },
      convertDayToShortDay (value) {
        let data = {
          'Mon': 'common.mon',
          'Tue': 'common.tue',
          'Wed': 'common.wed',
          'Thu': 'common.thu',
          'Fri': 'common.fri',
          'Sat': 'common._sat',
          'Sun': 'common.sub',
          'Pub': 'store.public_holiday'
        }
        return data[value]
      },
      saveCalendar (dataObject) {
        const data = this._.cloneDeep(dataObject);
        const { huts_day = [], order_duration = [], special_date_open = [], special_date_close = []} = data;

        // Filter to remove the past dates.
        const filteredSpecialDateOpen = special_date_open.filter(item => !vm.isPastDate(item.date));
        const filteredSpecialDateClose = special_date_close.filter(item => !vm.isPastDate(item.date));

        let hours = {}
        let todayNew = vm.$moment(new Date()).format('YYYY-MM-DD')
        hours.outlet_id = vm.item.outletId
        hours.huts_day = huts_day
        // hours.public_holiday = data['public_holiday']
        // Filter to remove the past dates.
        hours.advance_hours = order_duration.filter(item => !vm.isPastDate(item.date));

        // convert datetime for advance hours
        for (let i in hours.advance_hours) {
          if(vm.current_timezone && vm.current_timezone.time_zone){
            hours.advance_hours[i].opening = vm.checkDSTTime(todayNew + ' ' + hours.advance_hours[i].opening,vm.current_timezone.time_zone) ? vm.convertDateTimeFromTimezoneToUTC(todayNew + ' ' +hours.advance_hours[i].opening,vm.current_timezone.time_zone).add(1, 'hours').format('HH:mm:ss') : vm.convertDateTimeFromTimezoneToUTC(todayNew + ' ' + hours.advance_hours[i].opening,vm.current_timezone.time_zone).format('HH:mm:ss')
            hours.advance_hours[i].closing = vm.checkDSTTime(todayNew + ' ' + hours.advance_hours[i].closing,vm.current_timezone.time_zone) ? vm.convertDateTimeFromTimezoneToUTC(todayNew + ' ' +hours.advance_hours[i].closing,vm.current_timezone.time_zone).add(1, 'hours').format('HH:mm:ss') : vm.convertDateTimeFromTimezoneToUTC(todayNew + ' ' + hours.advance_hours[i].closing,vm.current_timezone.time_zone).format('HH:mm:ss')
          }else{
            hours.advance_hours[i].closing = this.convertDateTimeToUTCWithToday(hours.advance_hours[i].closing)
            hours.advance_hours[i].opening = this.convertDateTimeToUTCWithToday(hours.advance_hours[i].opening)
          }
        }
        hours.special_date = []
        let special_date = {}
        for (const openDate of filteredSpecialDateOpen) {
          special_date = {}
          special_date.name = openDate.name
          special_date.date = openDate.date
          special_date.opening = openDate.opening
          special_date.closing = openDate.closing
          special_date.status = 1
          // convert datetime for special date
          if(vm.current_timezone && vm.current_timezone.time_zone){
            special_date.opening = vm.checkDSTTime(todayNew + ' ' + special_date.opening,vm.current_timezone.time_zone) ? vm.convertDateTimeFromTimezoneToUTC(todayNew + ' ' +special_date.opening,vm.current_timezone.time_zone).add(1, 'hours').format('HH:mm:ss') : vm.convertDateTimeFromTimezoneToUTC(todayNew + ' ' + special_date.opening,vm.current_timezone.time_zone).format('HH:mm:ss')
            special_date.closing = vm.checkDSTTime(todayNew + ' ' + special_date.closing,vm.current_timezone.time_zone) ? vm.convertDateTimeFromTimezoneToUTC(todayNew + ' ' +special_date.closing,vm.current_timezone.time_zone).add(1, 'hours').format('HH:mm:ss') : vm.convertDateTimeFromTimezoneToUTC(todayNew + ' ' + special_date.closing,vm.current_timezone.time_zone).format('HH:mm:ss')
          }else{
            special_date.opening = this.convertDateTimeToUTCWithToday(special_date.opening)
            special_date.closing = this.convertDateTimeToUTCWithToday(special_date.opening)
          }
          hours.special_date.push(special_date)
        }
        for (let closeDate of filteredSpecialDateClose) {
          special_date = {}
          special_date.name = closeDate.name
          special_date.date = closeDate.date
          special_date.opening = closeDate.opening
          special_date.closing = closeDate.closing
          special_date.status = 0
          // convert datetime for special date
          if(vm.current_timezone && vm.current_timezone.time_zone){
            special_date.opening = vm.checkDSTTime(todayNew + ' ' + special_date.opening,vm.current_timezone.time_zone) ? vm.convertDateTimeFromTimezoneToUTC(todayNew + ' ' +special_date.opening,vm.current_timezone.time_zone).add(1, 'hours').format('HH:mm:ss') : vm.convertDateTimeFromTimezoneToUTC(todayNew + ' ' + special_date.opening,vm.current_timezone.time_zone).format('HH:mm:ss')
            special_date.closing = vm.checkDSTTime(todayNew + ' ' + special_date.closing,vm.current_timezone.time_zone) ? vm.convertDateTimeFromTimezoneToUTC(todayNew + ' ' +special_date.closing,vm.current_timezone.time_zone).add(1, 'hours').format('HH:mm:ss') : vm.convertDateTimeFromTimezoneToUTC(todayNew + ' ' + special_date.closing,vm.current_timezone.time_zone).format('HH:mm:ss')
          }else{
            special_date.opening = this.convertDateTimeToUTCWithToday(special_date.opening)
            special_date.closing = this.convertDateTimeToUTCWithToday(special_date.opening)
          }
          hours.special_date.push(special_date)
        }
        vm.calendarSaving = true;
        this.axios.outlet.updateOpenHours(hours, function (response) {
          vm.calendarSaving = false;
          vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        }, function () {
          vm.calendarSaving = false;
          vm.$toastr.error(vm.$t('message.error'), vm.$t('message.success'), {})
        })
      },
      getStoreCouponList () {
        let params = '?outlet_code=' + vm.item.code + '&limit=' + vm.couponDataTable.perPage + '&page=' + vm.couponDataTable.currentPage + '&sort_by=' + vm.couponDataTable.sort.field + '&order_by=' + vm.couponDataTable.sort.type
        vm.axios.outlet.getStoreCouponList(params, {
            cancelToken: new CancelToken(function executor (c) {
              cancel = c
            })
          },
          function (response) {
            vm.couponDataTable.items = response.data.data.items
            vm.couponDataTable.total = response.data.data.pagination.total
          },
          function (error) {
            //your code
          })
      },
      getPaymentMethods () {
        vm.axios.payment.getPaymentSimpleList(
          function (response) {
            vm.payment_method = response.data.data.items
            for (let i in vm.payment_method) {
              if (vm.payment_accepted[vm.payment_method[i].code] == null) {
                vm.payment_accepted[vm.payment_method[i].code] = {
                  active: 0,
                  min: 0,
                  max: 9999999999
                }
              }
            }
          },
          function (error) {
            //your code
          })
      },
      updatePaymentMethod () {
        // console.log(vm.payment_accepted)
      },
      updateNewMerchantId(data, path) {
        let merchant_id  = vm._.get(data, path, '')
        vm.item.merchant_payment_click_id = merchant_id
        vm.item.old_merchant_id = merchant_id
      },
      getMerchantPaymentIdDetails (storeCode) {
        vm.axios.payment.getMerchantPaymentIdDetails(storeCode,
          function (response) {
            vm.updateNewMerchantId(response, 'data.data.item.merchant_id')
          },
          function (error) {
            //your code
        })
      },
      createOrUpdateMerchantPaymentIdDetails (params) {
        vm.axios.payment.createOrUpdateMerchantPaymentIdDetails(params,
          function (response) {
            vm.updateNewMerchantId(response, 'data.data.item.item.merchant_id')
          },
          function (error) {
            //your code
        })
      },
    },
    created: function () {
      vm = this
      vm.clientId = localStorage.getItem('clientID')
      this.outlet_config = this.$store.getters.config.gms.outlet
      this.getPaymentMethods()
      let convertDateFormat = (val) => {
        val = this.convertUTCToClientTime(val)
        return this.$moment(val, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY HH:mm:ss')
      }

      let time_duration = parseInt(this.$store.getters.config.manual_config.number_time_duration) || 5

      for (let i = 5; i <= 90; i += 5) {
        this.intervalTime.D.push(i)
        this.intervalTime.C.push(i)
      }

      for (let i = time_duration; i <= 125; i = i + time_duration) {
        let text = i + this.$t('common.min')
        let value = i
        if (i > 120) {
          text = this.$t('common.more_than_min', {min: 120})
          value = 180
        }
        this.estimateTime.D.push({
          text: text,
          value: value
        })
      }
      this.estimateTime.D.push({
        text: this.$t('store.cannot_accept_order'),
        value: -1
      })
      for (let i = time_duration; i <= 125; i = i + time_duration) {
        let text = i + this.$t('common.min')
        let value = i
        if (i > 120) {
          text = this.$t('common.more_than_min', {min: 120})
          value = 180
        }
        this.estimateTime.C.push({
          text: text,
          value: value
        })
      }
      this.estimateTime.C.push({
        text: this.$t('store.cannot_accept_order'),
        value: -1
      })
      if (this.$route.params.uuid) {
        this.axios.outlet.getOutletDetail(this.$route.params.uuid,
          function (response) {
            let item = response.data.data.item
            vm.outlet_groups = item.outlet_groups
            vm.item.outletId = response.data.data.item.id
            for (let i in vm.aggregators) {
              if (vm.aggregators[i] == 1) {
                vm.aggregators_data[i] = 0
              }
            }
            if (item.aggregators == null) {
              item.aggregators = []
            }
            for (let i in item.aggregators) {
              if (vm.aggregators_data[item.aggregators[i]] != null) {
                vm.aggregators_data[item.aggregators[i]] = 1
              }
            }
            if (item.payment_accepted != null) {
              for (let i in item.payment_accepted) {
                vm.payment_accepted[i] = item.payment_accepted[i]
              }
            }

            const refurbishStatus = item.refurbishment ? item.refurbishment.status : 0;
            var position = {lat: item.lat, lng: item.long}
            vm.$set(vm.item, 'tier', item.tier)
            vm.$set(vm.item, 'id', item.id)
            vm.$set(vm.item, 'code', item.code)
            vm.$set(vm.item, 'code_validate', item.code_validate)
            vm.$set(vm.item, 'delivery_fee', item.delivery_fee)
            vm.$set(vm.item, 'tax_fee', item.tax_fee)
            vm.$set(vm.item, 'aggregator_code', item.aggregator_code)
            vm.$set(vm.item, 'email', item.email)
            vm.$set(vm.item, 'name', item.name ? item.name : {})
            vm.$set(vm.item, 'phone', item.phone ? item.phone : '')
            vm.$set(vm.item, 'active', item.active ? item.active : 0)
            vm.$set(vm.item, 'fax', item.fax ? item.fax : '')
            vm.$set(vm.item, 'offline_orders', 1)
            vm.$set(vm.item, 'online_orders', item.online_orders ? item.online_orders : 0)
            vm.$set(vm.item, 'alcohol_drinks_available', item.alcohol_drinks_available ? item.alcohol_drinks_available : 0)
            vm.$set(vm.item, 'refurbishment', refurbishStatus)
            vm.$set(vm.item, 'description', item.description ? item.description : {})
            vm.$set(vm.item, 'client_id', item.client_id)
            vm.$set(vm.item, 'lat', item.lat)
            vm.$set(vm.item, 'long', item.long)
            vm.$set(vm.item, 'street', item.street)
            vm.$set(vm.item, 'area_code', item.area_code)
            vm.$set(vm.item, 'jpchar', item.jpchar)
            vm.$set(vm.item, 'owner_code', item.owner_code)
            vm.$set(vm.item, 'owner_name', item.owner_name)
            // vm.$set(vm.item, 'remarks', item.customize != null && item.customize.remarks !== undefined ? item.customize.remarks : [])
            vm.$set(vm.item, 'disposition', item.disposition)
            vm.$set(vm.item, 'min_cart', item.min_cart ? item.min_cart : {})
            vm.$set(vm.item, 'quote_time', item.quote_time ? item.quote_time : {})
            vm.$set(vm.item, 'duration', item.duration ? item.duration : {})
            vm.$set(vm.item, 'division', item.division ? item.division : {})
            vm.$set(vm.item, 'tradezone', item.coords)
            vm.$set(vm.item, 'address', item.address ? item.address : {})
            vm.$set(vm.item, 'pos_ip', item.pos_ip)
            vm.$set(vm.item, 'gst_number', item.gst_number)
            vm.$set(vm.item, 'old_code', item.code)
            if(vm.outlet_config.config.show_payment_click_id) {
              vm.getMerchantPaymentIdDetails(item.code)
            }
            for (let i in item.customize) {
              vm.item[i] = item.customize[i]
            }
            vm.item.customize = item.customize

            if(item.timezone){
              let from_date = vm.checkDSTTime(item.from_date,item.timezone) ? vm.convertUTCToTimeZone(item.from_date,item.timezone).subtract(1,'hours').format('DD-MM-YYYY HH:mm:ss') : vm.convertUTCToTimeZone(item.from_date,item.timezone).format('DD-MM-YYYY HH:mm:ss')
              let to_date = vm.checkDSTTime(item.to_date,item.timezone) ? vm.convertUTCToTimeZone(item.to_date,item.timezone).subtract(1,'hours').format('DD-MM-YYYY HH:mm:ss') : vm.convertUTCToTimeZone(item.to_date,item.timezone).format('DD-MM-YYYY HH:mm:ss')
              vm.$set(vm.item,'from_date', from_date)
              vm.$set(vm.item,'to_date', to_date)
            }else{
              vm.$set(vm.item, 'from_date', vm.$moment(item.from_date, 'YYYY-MM-DD').format('DD-MM-YYYY HH:mm:ss'))
              vm.$set(vm.item, 'to_date', vm.$moment(item.to_date, 'YYYY-MM-DD').format('DD-MM-YYYY HH:mm:ss'))
            }

            // service fee
            if(vm.outlet_config.config.service_fee && item.service_fee && item.service_fee.active) {
              
              vm.serviceFee = item.service_fee
              let date = moment().format('YYYY-MM-DD')
              let dateServiceFeeFrom = date + ' ' + vm.serviceFee.time_apply.from
              let dateServiceFeeTo = date + ' ' + vm.serviceFee.time_apply.to

              if(item.timezone) {
                vm.serviceFee.time_apply.from = vm.checkDSTTime(dateServiceFeeFrom,item.timezone) ? vm.convertUTCToTimeZone(dateServiceFeeFrom,item.timezone).subtract(1,'hours').format('HH:mm') : vm.convertUTCToTimeZone(dateServiceFeeFrom,item.timezone).format('HH:mm')
               vm.serviceFee.time_apply.to = vm.checkDSTTime(dateServiceFeeTo,item.timezone) ? vm.convertUTCToTimeZone(dateServiceFeeTo,item.timezone).subtract(1,'hours').format('HH:mm') : vm.convertUTCToTimeZone(dateServiceFeeTo,item.timezone).format('HH:mm')
              } else {
                vm.serviceFee.time_apply.from = vm.convertDateFormat(dateServiceFeeFrom).format('HH:mm')
                vm.serviceFee.time_apply.to = vm.convertDateFormat(dateServiceFeeTo).format('HH:mm')
              }
            }
            vm.$set(vm.item, 'service_fee', vm.serviceFee)
            // end service fee
            
            vm.paths = item.coords ? item.coords : []
            vm.markers.push({position: position, label: '', draggable: false, title: ''})
            vm.quotetime_c = item.quote_time.C || 0
            vm.quotetime_d = item.quote_time.D || 0
            vm.quotetime_r = item.quote_time.R || 0
            if (typeof item.division.D !== 'undefined' && item.division.D == 2) {
              vm.item.quote_time.D = -1
            }
            if (typeof item.division.C !== 'undefined' && item.division.C == 2) {
              vm.item.quote_time.C = -1
            }
            // process remarks
            if (vm.item.remarks.length <= 0) {
              vm.item.remarks.push({'value': ''})
            }
            vm.axios.tenant.getTimezoneList([],
              function (response) {
                if(response.data.status && response.data.data.items.length > 0) {
                  vm.item.time_zones = response.data.data.items
                }
              })
            vm.current_timezone.time_zone = item.timezone ? item.timezone : this.$moment.tz.guess()
            vm.$forceUpdate('item')
            vm.$forceUpdate('current_timezone.time_zone')
            vm.delivery = 0
            vm.collection = 0
            vm.restaurant = 0
            if (item.disposition.length > 0) {
              for (var d in item.disposition) {
                if (item.disposition[d] == 'D') {
                  vm.delivery = 1
                }
                if (item.disposition[d] == 'C') {
                  vm.collection = 1
                }
                if (item.disposition[d] == 'R') {
                  vm.restaurant = 1
                }
              }
            }
            vm.refreshDataFirstAndSeconds()
            // openhour
            vm.calendarData.special_date_open = []
            vm.calendarData.special_date_close = []
            vm.calendarData.order_duration = []
            let outletId = vm.item.outletId
            vm.axios.outlet.getOpenHours(outletId, function (response) {
              let today = vm.$moment(new Date()).format('DD-MM-YYYY')
              let data = {
                'Mon': 'common.mon',
                'Tue': 'common.tue',
                'Wed': 'common.wed',
                'Thu': 'common.thu',
                'Fri': 'common.fri',
                'Sat': 'common.sat',
                'Sun': 'common.sun',
                'Pub': 'store.public_holiday'
              }
              let todayNew = vm.$moment(new Date()).format('YYYY-MM-DD')
              // process special dates
              if (response.data.data.items.special_date.length) {
                for (let i in response.data.data.items.special_date) {
                  if (response.data.data.items.special_date[i].status) {
                    let item = {
                      opening: response.data.data.items.special_date[i].opening.trim(),
                      closing: response.data.data.items.special_date[i].closing.trim(),
                      date: response.data.data.items.special_date[i].date,
                      name: response.data.data.items.special_date[i].name
                    }
                    // convert datetime
                    if (vm.current_timezone && vm.current_timezone.time_zone) {
                      item['opening'] = vm.checkDSTTime(todayNew + ' ' + item['opening'], vm.current_timezone.time_zone) ? vm.convertUTCToTimeZone(todayNew + ' ' + item['opening'], vm.current_timezone.time_zone).subtract(1, "hour").format('HH:mm:ss') : vm.convertUTCToTimeZone(todayNew + ' ' + item['opening'], vm.current_timezone.time_zone).format('HH:mm:ss')
                      item['closing'] = vm.checkDSTTime(todayNew + ' ' + item['closing'], vm.current_timezone.time_zone) ? vm.convertUTCToTimeZone(todayNew + ' ' + item['closing'], vm.current_timezone.time_zone).subtract(1, "hour").format('HH:mm:ss') : vm.convertUTCToTimeZone(todayNew + ' ' + item['closing'], vm.current_timezone.time_zone).format('HH:mm:ss')
                    } else {
                      item['opening'] = vm.convertDateFormatNotDay(todayNew + ' ' + item['opening'])
                      item['closing'] = vm.convertDateFormatNotDay(todayNew + ' ' + item['closing'])
                    }
                    vm.calendarData.special_date_open.push(item)
                  } else {
                    let item = {
                      opening: response.data.data.items.special_date[i].opening.trim(),
                      closing: response.data.data.items.special_date[i].closing.trim(),
                      date: response.data.data.items.special_date[i].date,
                      name: response.data.data.items.special_date[i].name
                    }
                    // convert datetime
                    if (vm.current_timezone && vm.current_timezone.time_zone) {
                      item['opening'] = vm.checkDSTTime(todayNew + ' ' + item['opening'], vm.current_timezone.time_zone) ? vm.convertUTCToTimeZone(todayNew + ' ' + item['opening'], vm.current_timezone.time_zone).subtract(1, "hour").format('HH:mm:ss') : vm.convertUTCToTimeZone(todayNew + ' ' + item['opening'], vm.current_timezone.time_zone).format('HH:mm:ss')
                      item['closing'] = vm.checkDSTTime(todayNew + ' ' + item['closing'], vm.current_timezone.time_zone) ? vm.convertUTCToTimeZone(todayNew + ' ' + item['closing'], vm.current_timezone.time_zone).subtract(1, "hour").format('HH:mm:ss') : vm.convertUTCToTimeZone(todayNew + ' ' + item['closing'], vm.current_timezone.time_zone).format('HH:mm:ss')
                    } else {
                      item['opening'] = vm.convertDateFormatNotDay(todayNew + ' ' + item['opening'])
                      item['closing'] = vm.convertDateFormatNotDay(todayNew + ' ' + item['closing'])
                    }
                    vm.calendarData.special_date_close.push(item)
                  }
                }
              }
              // process lunch time
              let lunch_times = []
              if (response.data.data.items.lunch_time.length) {
                for (let i in response.data.data.items.lunch_time) {
                  let lunch_time = response.data.data.items.lunch_time[i]
                  // convert datetime
                  if(vm.current_timezone && vm.current_timezone.time_zone){
                    lunch_time['opening'] = vm.checkDSTTime(todayNew + ' ' + lunch_time['opening'],vm.current_timezone.time_zone) ? vm.convertUTCToTimeZone(todayNew + ' ' + lunch_time['opening'],vm.current_timezone.time_zone).subtract(1, "hour").format('HH:mm:ss') : vm.convertUTCToTimeZone(todayNew + ' ' + lunch_time['opening'],vm.current_timezone.time_zone).format('HH:mm:ss')
                    lunch_time['closing'] = vm.checkDSTTime(todayNew + ' ' + lunch_time['closing'],vm.current_timezone.time_zone) ? vm.convertUTCToTimeZone(todayNew + ' ' + lunch_time['closing'],vm.current_timezone.time_zone).subtract(1, "hour").format('HH:mm:ss') : vm.convertUTCToTimeZone(todayNew + ' ' + lunch_time['closing'],vm.current_timezone.time_zone).format('HH:mm:ss')
                  }else{
                    lunch_time['opening'] = vm.convertDateFormatNotDay(todayNew + ' ' + lunch_time['opening'])
                    lunch_time['closing'] = vm.convertDateFormatNotDay(todayNew + ' ' + lunch_time['closing'])
                  }
                  if (lunch_time['active']) {
                    let key = lunch_time['opening'].trim() + '-' + lunch_time['closing'].trim()
                    if (!lunch_times[key]) {
                      lunch_times[key] = {
                        opening: lunch_time['opening'].trim().substring(0, lunch_time['opening'].trim().length - 3),
                        closing: lunch_time['closing'].trim().substring(0, lunch_time['closing'].trim().length - 3),
                        days: [],
                        order_type: lunch_time['order_type'].trim()
                      }
                    }
                    lunch_times[key].days.push(data[lunch_time['day']])
                  }
                }
                for (let i in lunch_times) {
                  let itemLunchTimeHour = {
                    0: {
                      'date': 'common.mon',
                      'proper_date': 'Mon',
                      'status': lunch_times[i].days.indexOf('Mon') > -1 ? 1 : 0
                    },
                    1: {
                      'date': 'common.tue',
                      'proper_date': 'Tue',
                      'status': lunch_times[i].days.indexOf('Tue') > -1 ? 1 : 0
                    },
                    2: {
                      'date': 'common.wed',
                      'proper_date': 'Wed',
                      'status': lunch_times[i].days.indexOf('Wed') > -1 ? 1 : 0
                    },
                    3: {
                      'date': 'common.thu',
                      'proper_date': 'Thu',
                      'status': lunch_times[i].days.indexOf('Thu') > -1 ? 1 : 0
                    },
                    4: {
                      'date': 'common.fri',
                      'proper_date': 'Fri',
                      'status': lunch_times[i].days.indexOf('Fri') > -1 ? 1 : 0
                    },
                    5: {
                      'date': 'common.sat',
                      'proper_date': 'Sat',
                      'status': lunch_times[i].days.indexOf('Sat') > -1 ? 1 : 0
                    },
                    6: {
                      'date': 'common.sun',
                      'proper_date': 'Sun',
                      'status': lunch_times[i].days.indexOf('Sun') > -1 ? 1 : 0
                    },
                    7: {
                      'date': 'store.public_holiday',
                      'proper_date': 'Pub',
                      'status': lunch_times[i].days.indexOf('Pub') > -1 ? 1 : 0
                    },
                    8: {'date': 'store.from', 'value': lunch_times[i]['opening']},
                    9: {'date': 'store.to', 'value': lunch_times[i]['closing']},
                    10: {'date': 'selectedLunchHour', 'value': lunch_times[i].days},
                    11: {'date': 'store.order_type', 'value': lunch_times[i].order_type}
                  }
                  vm.item.lunchTimeHours.push(itemLunchTimeHour)
                }
              }
              // process open hours
              let open_hours = []
              if (response.data.data.items.open_hours.length) {
                for (let i in response.data.data.items.open_hours) {
                  let open_hour = response.data.data.items.open_hours[i]
                  if(vm.current_timezone && vm.current_timezone.time_zone){
                    open_hour['opening'] = vm.checkDSTTime(todayNew + ' ' + open_hour['opening'],vm.current_timezone.time_zone) ? vm.convertUTCToTimeZone(todayNew + ' ' + open_hour['opening'],vm.current_timezone.time_zone).subtract(1, "hour").format('HH:mm:ss') : vm.convertUTCToTimeZone(todayNew + ' ' + open_hour['opening'],vm.current_timezone.time_zone).format('HH:mm:ss')
                    open_hour['closing'] = vm.checkDSTTime(todayNew + ' ' + open_hour['closing'],vm.current_timezone.time_zone) ? vm.convertUTCToTimeZone(todayNew + ' ' + open_hour['closing'],vm.current_timezone.time_zone).subtract(1, "hour").format('HH:mm:ss') : vm.convertUTCToTimeZone(todayNew + ' ' + open_hour['closing'],vm.current_timezone.time_zone).format('HH:mm:ss')
                  }else{
                    open_hour['opening'] = vm.convertDateFormatNotDay(todayNew + ' ' + open_hour['opening'])
                    open_hour['closing'] = vm.convertDateFormatNotDay(todayNew + ' ' + open_hour['closing'])
                  }
                  if (open_hour['active']) {
                    let key = open_hour['opening'].trim() + '-' + open_hour['closing'].trim() + '-' + open_hour['order_type'].trim()
                    if (!open_hours[key]) {
                      open_hours[key] = {
                        opening: open_hour['opening'].trim().substring(0, open_hour['opening'].trim().length - 3),
                        closing: open_hour['closing'].trim().substring(0, open_hour['closing'].trim().length - 3),
                        days: [],
                        order_type: open_hour['order_type'].trim()
                      }
                    }
                    open_hours[key].days.push(data[open_hour['day']])
                  }
                }
                for (let i in open_hours) {
                  let itemBusinessHour = {
                    0: {
                      'date': 'common.mon',
                      'proper_date': 'Mon',
                      'status': open_hours[i].days.indexOf('Mon') > -1 ? 1 : 0
                    },
                    1: {
                      'date': 'common.tue',
                      'proper_date': 'Tue',
                      'status': open_hours[i].days.indexOf('Tue') > -1 ? 1 : 0
                    },
                    2: {
                      'date': 'common.wed',
                      'proper_date': 'Wed',
                      'status': open_hours[i].days.indexOf('Wed') > -1 ? 1 : 0
                    },
                    3: {
                      'date': 'common.thu',
                      'proper_date': 'Thu',
                      'status': open_hours[i].days.indexOf('Thu') > -1 ? 1 : 0
                    },
                    4: {
                      'date': 'common.fri',
                      'proper_date': 'Fri',
                      'status': open_hours[i].days.indexOf('Fri') > -1 ? 1 : 0
                    },
                    5: {
                      'date': 'common.sat',
                      'proper_date': 'Sat',
                      'status': open_hours[i].days.indexOf('Sat') > -1 ? 1 : 0
                    },
                    6: {
                      'date': 'common.sun',
                      'proper_date': 'Sun',
                      'status': open_hours[i].days.indexOf('Sun') > -1 ? 1 : 0
                    },
                    7: {
                      'date': 'store.public_holiday',
                      'proper_date': 'Pub',
                      'status': open_hours[i].days.indexOf('Pub') > -1 ? 1 : 0
                    },
                    8: {'date': 'store.from', 'value': open_hours[i]['opening']},
                    9: {'date': 'store.to', 'value': open_hours[i]['closing']},
                    10: {'date': 'selectedBusinessHour', 'value': open_hours[i].days},
                    11: {'date': 'store.order_type', 'value': open_hours[i].order_type}
                  }
                  vm.item.businessHours.push(itemBusinessHour)
                }
              }
              // process lunch times if null
              if (vm.item.lunchTimeHours.length <= 0) {
                let selectedLunchHour = []
                let itemLunchTimeHour = {
                  0: {'date': 'common.mon', 'proper_date': 'Mon', 'status': 0},
                  1: {'date': 'common.tue', 'proper_date': 'Tue', 'status': 0},
                  2: {'date': 'common.wed', 'proper_date': 'Wed', 'status': 0},
                  3: {'date': 'common.thu', 'proper_date': 'Thu', 'status': 0},
                  4: {'date': 'common.fri', 'proper_date': 'Fri', 'status': 0},
                  5: {'date': 'common.sat', 'proper_date': 'Sat', 'status': 0},
                  6: {'date': 'common.sun', 'proper_date': 'Sun', 'status': 0},
                  7: {'date': 'store.public_holiday', 'proper_date': 'Pub', 'status': 0},
                  8: {'date': 'store.from', 'value': '08:00'},
                  9: {'date': 'store.to', 'value': '23:59'},
                  10: {'date': 'selectedLunchHour', 'value': selectedLunchHour},
                  11: {'date': 'store.order_type', 'value': '["D","C","R"]'}
                }
                vm.item.lunchTimeHours.push(itemLunchTimeHour)
              }
              // process bussiness hours if null
              if (vm.item.businessHours.length <= 0) {
                let selectedBusinessHour = []
                let itemBusinessHour = {
                  0: {'date': 'common.mon', 'proper_date': 'Mon', 'status': 0},
                  1: {'date': 'common.tue', 'proper_date': 'Tue', 'status': 0},
                  2: {'date': 'common.wed', 'proper_date': 'Wed', 'status': 0},
                  3: {'date': 'common.thu', 'proper_date': 'Thu', 'status': 0},
                  4: {'date': 'common.fri', 'proper_date': 'Fri', 'status': 0},
                  5: {'date': 'common.sat', 'proper_date': 'Sat', 'status': 0},
                  6: {'date': 'common.sun', 'proper_date': 'Sun', 'status': 0},
                  7: {'date': 'store.public_holiday', 'proper_date': 'Pub', 'status': 0},
                  8: {'date': 'store.from', 'value': '08:00'},
                  9: {'date': 'store.to', 'value': '23:59'},
                  10: {'date': 'selectedBusinessHour', 'value': selectedBusinessHour},
                  11: {'date': 'store.order_type', 'value': '["D","C","R"]'}
                }
                vm.item.businessHours.push(itemBusinessHour)
              }
              // vm.calendarData.order_duration = response.data.data.items.advance_hours
              vm.calendarData.order_duration = []
              if (response.data.data.items.advance_hours.length) {
                for (let i in response.data.data.items.advance_hours) {
                  let item = {
                    opening: response.data.data.items.advance_hours[i].opening.trim(),
                    closing: response.data.data.items.advance_hours[i].closing.trim(),
                    date: response.data.data.items.advance_hours[i].date,
                    duration: response.data.data.items.advance_hours[i].duration,
                    name: response.data.data.items.advance_hours[i].name
                  }
                  // convert datetime
                  if(vm.current_timezone && vm.current_timezone.time_zone){
                    item['opening'] = vm.checkDSTTime(todayNew + ' ' + item['opening'],vm.current_timezone.time_zone) ? vm.convertUTCToTimeZone(todayNew + ' ' + item['opening'],vm.current_timezone.time_zone).subtract(1, "hour").format('HH:mm:ss') : vm.convertUTCToTimeZone(todayNew + ' ' + item['opening'],vm.current_timezone.time_zone).format('HH:mm:ss')
                    item['closing'] = vm.checkDSTTime(todayNew + ' ' + item['closing'],vm.current_timezone.time_zone) ? vm.convertUTCToTimeZone(todayNew + ' ' + item['closing'],vm.current_timezone.time_zone).subtract(1, "hour").format('HH:mm:ss') : vm.convertUTCToTimeZone(todayNew + ' ' + item['closing'],vm.current_timezone.time_zone).format('HH:mm:ss')
                  }else{
                    item['opening'] = vm.convertDateFormatNotDay(todayNew + ' ' + item['opening'])
                    item['closing'] = vm.convertDateFormatNotDay(todayNew + ' ' + item['closing'])
                  }
                  vm.calendarData.order_duration.push(item)
                }
              }
              vm.calendarData.huts_day = response.data.data.items.huts_day
              vm.calendarData.public_holiday = response.data.data.items.public_holiday
            })
            vm.updateCustomizeField = true
            // Get store coupon list
            vm.getStoreCouponList()
            if (vm.$store.getters.config.gms.outlet.config.show_push_to_prod) {
              vm.checkShowPublishButton()
            } else {
              vm.isShowPublishButton = true
            }
          })
      } else {
        let bussinessHours = this.getNewDatesItem(this.item.businessHours, 'selectedBusinessHour')
        this.item.businessHours.push(bussinessHours)
        let lunchTimeHours = this.getNewDatesItem(this.item.lunchTimeHours, 'selectedLunchTimeHour')
        this.item.lunchTimeHours.push(lunchTimeHours)
        this.item.remarks.push({'value': ''})
        this.updateCustomizeField = true
      }
      let langs = this.$store.getters.languages
      for (let l in langs) {
        this.order_types[langs[l]] = [
          {text: this.$t('common.all', langs[l]), value: '["D","C","R"]'},
          {text: this.$t('common.delivery', langs[l]), value: '["D"]'},
          {text: this.$t('common.takeaway', langs[l]), value: '["C"]'}
        ]
      }
    },
    watch: {
      'couponDataTable.currentPage': function (val) {
        this.getStoreCouponList()
      },
      'couponDataTable.perPage': function (val) {
        this.getStoreCouponList()
      },
      'serviceFee.time_apply.from': function(val) {
        this.checkTimeService(true)
      },
      'serviceFee.time_apply.to': function(val) {
        this.checkTimeService(false)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/admin/outlets/OutletsForm.vue